import React, { useState, useEffect, useMemo, useRef } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import { Spin, Input, Image, Typography, Table, Tabs, Dropdown, Menu, Tooltip } from 'antd';
import { PoweroffOutlined, SearchOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import FullScreenButton from 'src/components/common/FullScreenButton';
import { useHistory, Link, useLocation } from 'react-router-dom';
import VimeoVideo from 'src/components/common/VimeoVideo';
import LeftMenu2 from 'src/components/LevelUp/LeftMenu/index2.js';
import { Carousel3, CarouselItem3 } from 'src/components/LevelUp/Carousel';
import _ from 'lodash';
import { EXTERNAL_STUDY_BOOK } from 'src/operations/queries/externalStudy';
import { FAVORITE_BOOK } from 'src/operations/mutations/externalUserStudy';
import { useQuery, useMutation } from '@apollo/client';
import { userInfoVar } from 'src/apollo/cache';
import { GET_DAILY_EXTERNAL_STUDY_SCHEDULE_DUE } from 'src/operations/queries/getClass';
import { GET_STUDENT_LUPUSER, GET_TEACHER_USER } from 'src/operations/queries/getUser';
import { EXTERNAL_USER_STUDY_LEVELUP } from 'src/operations/queries/externalStudy';
import { EXTERNAL_STUDY_RANKING_LIST } from 'src/operations/queries/study';
import { getLixileScoreObject } from 'src/utils/index';
import { MXLEVEL_TO_AGL, MXLEVEL_TO_LEXILE } from 'src/constants/common';
import { LEVEL_UP_POINT } from 'src/operations/queries/book';
import { isMobileOnly } from 'react-device-detect';
import moment from 'moment';
// Helper component to fetch and render guide video
import { useSelector } from 'react-redux';
const { Text } = Typography;
// const { Carousel, CarouselItem } = Carousels;
const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding-top: ${({ isMobile }) => (isMobile ? '0' : '64px')};
  overflow-x: hidden;
  overflow-y: ${({ isMobile }) => (isMobile ? 'auto' : 'hidden')};
  overscroll-behavior: contain;
  background:
    radial-gradient(ellipse 800px 500px at 15% 30%, rgba(34, 211, 238, 0.08) 0%, transparent 70%),
    radial-gradient(ellipse 600px 400px at 85% 70%, rgba(16, 185, 129, 0.06) 0%, transparent 70%),
    radial-gradient(ellipse 500px 300px at 50% 10%, rgba(139, 92, 246, 0.04) 0%, transparent 70%), #e8f4f8;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(8, 145, 178, 0.08);
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #7dd3fc, #0891b2);
    border-radius: 999px;
    border: 3px solid #e8f4f8;
  }
`;
const MobileLevelDropdownStyle = createGlobalStyle`
  .cust-my-page,
  .cust-my-page * {
    font-family: 'Nunito', sans-serif;
  }

  .levelup-mobile-dd {
    .ant-dropdown-menu-item {
      padding-left: 10px !important;
    }
  }
`;
const floatMotion = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
`;
const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
`;
const ColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
`;
const Header = styled(RowFlex)`
  display: ${({ isMobile }) => (isMobile ? 'flex' : 'none')};
  justify-content: start;
  align-items: center;
  height: ${({ heightScale, isMobile }) => (isMobile ? '64px' : `${75 * heightScale}px`)};
  /* height: 75*height +'px'; */
  min-height: ${({ heightScale, isMobile }) => (isMobile ? '56px' : `${55 * heightScale}px`)};
  padding-left: ${({ heightScale, isMobile }) => (isMobile ? '12px' : `45px`)};
  padding-right: ${({ heightScale, isMobile }) => (isMobile ? '12px' : `${10 * heightScale}px`)};
  background-color: #ffffff;
  background-image: none;
  line-height: ${({ heightScale, isMobile }) => (isMobile ? '56px' : `${64 * heightScale}px`)};
`;
const HeadBox = styled.div`
  height: ${({ heightScale }) => `${43 * heightScale}px`};
  line-height: ${({ heightScale }) => `${43 * heightScale}px`};
  font-size: ${({ heightScale }) => `${1.5 * heightScale}em`};
  font-weight: bolder;
  border-radius: 5px;
  background-color: ${(props) => (props.background ? props.background : '#fff')};
  color: ${(props) => props.color};
  padding: 0 ${({ heightScale }) => `${20 * heightScale}px`};
  margin-right: ${({ heightScale }) => `${30 * heightScale}px`};
`;
const MobileHeaderRow = styled(RowFlex)`
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
const MobileIconButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #6b4b32;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;
const MobileSpacer = styled.div`
  width: 34px;
  height: 34px;
`;
const MobileActions = styled(RowFlex)`
  gap: 8px;
  align-items: center;
`;
const MobileLevelBar = styled.div`
  width: 100%;
  background-color: #ddd4c7;
  padding: 8px 15px;
  display: flex;
  justify-content: flex-start;
`;
const MobileLevelDropdown = styled.div`
  background-color: #ffffff;
  height: 32px;
  min-width: 140px;
  border-radius: 8px;
  font-size: 13px;
  color: #6b4b32;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 24px 0 12px;
  background-image: url('/images/LevelUp/mobileHeaderTriangle.png');
  background-repeat: no-repeat;
  background-size: 10px 9px;
  background-position: right 8px center;
  cursor: pointer;
`;
const MobileSearchBar = styled.div`
  margin-top: -14px;
  padding: 6px 12px;
  background-color: #ffffff;
  /* display: flex;
  justify-content: center;
  align-items: center; */
`;
const MobileSearchInput = styled(Input)`
  height: 36px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 18px;
  border: 2px solid #dcd7cc;
  padding: 0 16px;
  font-size: 14px;
  :hover {
    background-color: #ffffff;
    border: 2px solid #dcd7cc;
  }
`;
const SearchInput = styled(Input)`
  height: 50px;
  width: 200px;
  background-color: #ffffff;
  border-radius: 25px;
  border: 2px solid #dcd7cc;
  padding: 15px 20px;
  font-size: 15px;
  :hover {
    background-color: #ffffff;
    border: 2px solid #dcd7cc;
  }
`;
const CloseButton = styled.div`
  cursor: pointer;
  border-radius: 50px;
  font-size: 1.3em;
  font-weight: 900;
  color: #666666;
  /* background: #ed7d31; */
  width: 43px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;
const MainWrapper = styled(ColumnFlex)`
  min-height: calc(100vh - 64px);
  height: auto;
  width: 100%;
  align-items: stretch;
  margin: 0;
  @media (max-width: 1280px) {
    min-height: 620px;
  }
`;
const Main = styled(RowFlex)`
  min-height: 0;
  height: ${({ isMobile }) => (isMobile ? 'auto' : 'calc(100vh - 64px)')};
  width: 100%;
  padding: ${({ isMobile }) => (isMobile ? '0' : '0')};
  background-color: transparent;
  justify-content: flex-start;
  align-items: stretch;
  gap: ${({ isMobile }) => (isMobile ? '16px' : '24px')};
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};

  @media (max-width: 1320px) {
    gap: ${({ isMobile }) => (isMobile ? '16px' : '14px')};
  }
`;
const DesktopLeftMenuWrap = styled.div`
  display: contents;

  > nav {
    width: 238px;
    min-width: 238px;
    padding: 14px;
  }

  > nav button {
    font-size: 14px;
    padding: 9px 14px;
  }

  > nav span {
    font-size: inherit;
  }

  @media (max-width: 1280px) {
    > nav {
      width: 206px;
      min-width: 206px;
      padding: 10px;
    }

    > nav button {
      font-size: 13px;
      padding: 8px 10px;
    }
  }

  @media (max-width: 1180px) {
    > nav {
      width: 188px;
      min-width: 188px;
    }
  }
`;
const RightRail = styled(ColumnFlex)`
  height: calc(100vh - 64px);
  width: clamp(248px, 24vw, 308px);
  min-width: 248px;
  padding: 14px 12px 14px 12px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 0 1 clamp(248px, 24vw, 308px);
  background: #ffffff;
  border-left: 1.5px solid rgba(8, 145, 178, 0.12);

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(8, 145, 178, 0.22);
    border-radius: 2px;
  }

  @media (max-width: 1320px) {
    width: 220px;
    min-width: 220px;
    flex-basis: 220px;
    padding: 10px 8px;
  }

  @media (max-width: 1180px) {
    width: 204px;
    min-width: 204px;
    flex-basis: 204px;
  }
`;
const Title = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.15;
  color: #0c1a2e;
  display: flex;
  align-items: center;
  gap: 8px;
`;
const MiddleBox = styled(ColumnFlex)`
  background-color: #fff;
  border: 1.5px solid rgba(8, 145, 178, 0.14);
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding-top: 18px;
  padding-bottom: 20px;
  padding-left: 24px;
  align-items: center;
  padding-right: 24px;
  box-sizing: border-box;
  @media (max-width: 1280px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
const MiddleInnerBox = styled(RowFlex)`
  width: 100%;
  height: 203px;
  background-color: #fff;
  border-radius: 14px;
  overflow: hidden;
  padding: 10px;
  padding-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  margin: auto 0;
`;
const AssignedImg = styled(ColumnFlex)`
  cursor: ${(props) => (props.is_completed ? 'default' : 'pointer')};
  width: 135px;
  height: 180px;
  background-image: url(${(props) => props.src});
  background-size: 135px 180px;
  justify-content: center;
  align-items: center;
`;
const MiddleInnerText = styled.div`
  font-size: 15px;
  color: ${(props) => (props.color ? props.color : '#000000')};
  line-height: 20px;
  font-weight: 600;
`;
const RightBox = styled(ColumnFlex)`
  width: 100%;
  background: #ffffff;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  border-radius: 20px;
  padding: 18px;
  margin-bottom: 14px;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  box-sizing: border-box;
`;
const RightTopStack = styled(ColumnFlex)`
  width: 100%;
  gap: 12px;
  margin-bottom: 14px;
`;
const ProfileHero = styled.div`
  background: linear-gradient(135deg, #0891b2, #06b6d4, #10b981);
  border-radius: 22px;
  padding: 18px 18px 16px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(8, 145, 178, 0.2);

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.12) 1px, transparent 1px);
    background-size: 18px 18px;
    pointer-events: none;
  }
`;
const HeroTopRow = styled(RowFlex)`
  position: relative;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
`;
const HeroAvatar = styled.div`
  width: 58px;
  height: 58px;
  border-radius: 50%;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.22);
  border: 3px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;
const HeroName = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  color: #ffffff;
  font-size: 15px;
  font-weight: 900;
  line-height: 1.2;
`;
const HeroId = styled.div`
  font-family: 'JetBrains Mono', monospace;
  color: rgba(255, 255, 255, 0.78);
  font-size: 10px;
  font-weight: 700;
  line-height: 1.3;
`;
const HeroGrade = styled.div`
  font-family: 'Nunito', sans-serif;
  color: rgba(255, 255, 255, 0.82);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.3;
`;
const HeroBottomRow = styled(RowFlex)`
  position: relative;
  justify-content: space-between;
  align-items: flex-end;
`;
const HeroLexileValue = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  color: #ffffff;
  font-size: ${({ $clickable }) => ($clickable ? '13px' : '22px')};
  font-weight: 900;
  line-height: 1;
  max-width: 132px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
`;
const HeroLexileLabel = styled.div`
  font-family: 'Nunito', sans-serif;
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.74);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
`;
const HeroMxBadge = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  padding: 6px 14px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
`;
const ClassLevelCard = styled.div`
  margin-top: 12px;
  padding: 18px 16px;
  border-radius: 18px;
  border: 1.5px solid rgba(8, 145, 178, 0.14);
  background: #f0f9ff;
  box-shadow: 0 2px 10px rgba(8, 145, 178, 0.1);
`;
const ClassLevelTop = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;
const ClassLevelKicker = styled.div`
  font-family: 'JetBrains Mono', monospace;
  color: #8fa3bb;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
`;
const ClassLevelName = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  margin-top: 4px;
  color: #0891b2;
  font-size: 18px;
  font-weight: 900;
`;
const ClassLevelBadge = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: linear-gradient(135deg, #0891b2, #06b6d4);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 900;
  box-shadow: 0 6px 18px rgba(8, 145, 178, 0.24);
`;
const SubTitle = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.15;
  color: #0c1a2e;
  display: flex;
  align-items: center;
  gap: 7px;
  @media (max-width: 1280px) {
    font-size: 15px;
  }
`;
const InfoText = styled(RowFlex)`
  font-family: 'Nunito', sans-serif;
  color: ${(props) => (props.color ? props.color : '#4a6380')};
  font-size: 12px;
  line-height: 1.5;
  align-items: center;
  /* text-align: center; */
`;
const InfoBtn = styled(RowFlex)`
  font-family: 'Nunito', sans-serif;
  width: 100%;
  height: 52px;
  background: linear-gradient(135deg, #f97316, #ea580c);
  border-radius: 18px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 10px 0 15px;
  cursor: pointer;
`;
const PointText = styled(RowFlex)`
  align-items: baseline;
  gap: 6px;
  padding: 8px 0 10px;
`;
const PointNow = styled.span`
  font-family: 'Baloo 2', sans-serif !important;
  color: #f97316;
  font-size: 20px;
  font-weight: 900;
  line-height: 1;
`;
const PointGoal = styled.span`
  font-family: 'JetBrains Mono', monospace;
  color: #8fa3bb;
  font-size: 13px;
  font-weight: 700;
`;
const PointGraph = styled.div`
  border: 1.5px solid rgba(8, 145, 178, 0.14);
  width: 100%;
  height: 14px;
  border-radius: 14px;
  background: #f0f9ff;
`;
const GraphFill = styled.div`
  border-radius: 14px 0 0 14px;
  height: 100%;
  width: ${(props) => `${(props.mypoint * 100) / props.totalpoint}%`};
  background-color: #ffc066;
`;
const PointDetailList = styled(ColumnFlex)`
  gap: 8px;
  margin-top: 14px;
`;
const PointNote = styled.div`
  font-family: 'JetBrains Mono', monospace;
  margin-top: 8px;
  color: #8fa3bb;
  font-size: 10px;
  font-weight: 700;
  text-align: right;
`;
const PointDetailRow = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  border-radius: 12px;
  background: #eef8fd;
  font-size: 12px;
  color: #5f4a34;
`;
const PointDetailLabel = styled.span`
  font-family: 'Nunito', sans-serif;
  font-weight: 700;
`;
const PointDetailValue = styled.span`
  font-family: 'Nunito', sans-serif;
  padding: 2px 8px;
  border-radius: 999px;
  background: ${(props) => props.background || 'rgba(8, 145, 178, 0.1)'};
  color: ${(props) => props.color || '#0891b2'};
  font-size: 11px;
  font-weight: 800;
`;
const RankValue = styled.span`
  font-family: 'Nunito', sans-serif;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 900;
  color: ${(props) => props.color || '#4a6380'};
  background: ${(props) => props.background || '#dbeafe'};
  box-shadow: ${(props) => props.shadow || 'none'};
`;
const BookCountBadge = styled.span`
  font-family: 'Nunito', sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 999px;
  background: #eaf7fb;
  color: #0891b2;
  font-size: 12px;
  font-weight: 900;
`;
const CenterScroll = styled(ColumnFlex)`
  flex: 1;
  padding: 22px 22px 22px 0;
  gap: 18px;
  min-width: 0;
  height: calc(100vh - 64px);
  align-items: stretch;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(8, 145, 178, 0.22);
    border-radius: 2px;
  }

  @media (max-width: 1320px) {
    padding: 14px 10px 18px 0;
    gap: 14px;
  }
`;
const WelcomeBanner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 18px;
  padding: 24px 28px;
  min-height: 168px;
  border-radius: 28px;
  background: linear-gradient(135deg, #0891b2, #06b6d4, #10b981);
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0 10px 30px rgba(8, 145, 178, 0.22);
  color: #ffffff;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.12) 1px, transparent 1px);
    background-size: 18px 18px;
    pointer-events: none;
  }
`;
const WelcomeLeft = styled(ColumnFlex)`
  align-items: flex-start;
  position: relative;
  gap: 8px;
  flex: 1;
`;
const WelcomeGreeting = styled.div`
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
`;
const WelcomeName = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  font-size: 24px;
  font-weight: 900;
  line-height: 1.15;
`;
const WelcomeSub = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.86);
`;
const WelcomeChips = styled(RowFlex)`
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;
const WelcomeChip = styled.div`
  font-family: 'Nunito', sans-serif;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  font-size: 11px;
  font-weight: 800;
  backdrop-filter: blur(4px);
`;
const WelcomeRight = styled(ColumnFlex)`
  position: relative;
  align-items: center;
  justify-content: center;
  min-width: 208px;
  flex-shrink: 0;
  gap: 12px;
`;
const LexileCircle = styled.div`
  width: 90px;
  height: 90px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 3px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
  animation: ${floatMotion} 3s ease infinite;
`;
const LexileCircleValue = styled.div`
  font-family: 'Baloo 2', sans-serif !important;
  font-size: ${({ $clickable }) => ($clickable ? '9px' : '22px')};
  font-weight: 900;
  line-height: 1;
  max-width: ${({ $clickable }) => ($clickable ? '84px' : '74px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
`;
const LexileCircleLabel = styled.div`
  margin-top: 6px;
  font-family: 'Nunito', sans-serif;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.75);
`;
const WelcomeLevel = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 11px;
  font-weight: 800;
  padding: 4px 14px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.35);
`;
const MainSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const SectionHead = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
`;
const SectionTitleWrap = styled(RowFlex)`
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
`;
const SectionLevelBadge = styled.span`
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 20px;
  background: rgba(8, 145, 178, 0.1);
  color: #0891b2;
  border: 1px solid rgba(8, 145, 178, 0.25);
`;
const SectionMore = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  font-family: 'Nunito', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #0891b2;
  cursor: pointer;
`;
const RecommendedOuter = styled(RowFlex)`
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 0 58px;

  @media (max-width: 1320px) {
    padding: 0 34px;
  }

  @media (max-width: 1180px) {
    padding: 0 28px;
  }
`;
const CarouselNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  background: #ffffff;
  color: #0891b2;
  font-size: 16px;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  cursor: pointer;
  transition: all 0.18s;
  z-index: 5;

  &:hover {
    background: #0891b2;
    color: #ffffff;
    border-color: #0891b2;
  }

  @media (max-width: 1320px) {
    width: 32px;
    height: 32px;
  }
`;
const RecommendedGrid = styled.div`
  width: min(100%, ${({ $columns }) => ($columns <= 2 ? '430px' : $columns === 3 ? '640px' : '760px')});
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns || 4}, minmax(0, 1fr));
  gap: 12px;
`;
const BookCard = styled.div`
  cursor: pointer;
  background: #ffffff;
  border-radius: 20px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  transition: all 0.22s;

  &:hover {
    transform: translateY(-6px) scale(1.01);
    border-color: #0891b2;
    box-shadow: 0 12px 48px rgba(8, 145, 178, 0.2);
  }
`;
const BookCover = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 3 / 4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #eaf7fb 0%, #cfe8f4 55%, #7f977f 100%);
`;
const BookCoverImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: fill;
  display: block;
`;
const BookCoverShade = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.6) 100%);
`;
const BookDoneBadge = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981, #059669);
  border: 2.5px solid rgba(255, 255, 255, 0.5);
  color: #ffffff;
  font-family: 'Baloo 2', sans-serif !important;
  font-size: 7px;
  font-weight: 900;
  letter-spacing: 0.04em;
  text-align: center;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);
`;
const BookMetaTag = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  z-index: 2;
  background: rgba(8, 145, 178, 0.85);
  border-radius: 20px;
  padding: 3px 8px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #ffffff;
  backdrop-filter: blur(4px);
`;
const BookHeart = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: ${(props) => (props.$active ? '#fee2e2' : 'rgba(255,255,255,.92)')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.18s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 2;

  &:hover {
    transform: scale(1.2);
    background: #ffffff;
  }
`;
const BookTitle = styled.div`
  padding: 12px 14px 14px;
  text-align: center;
  font-family: 'Nunito', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #0c1a2e;
  line-height: 1.35;
`;
const RecommendedDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  margin-top: 14px;
`;
const RecommendedDot = styled.button`
  height: 5px;
  width: ${(props) => (props.active ? '18px' : '5px')};
  border: none;
  border-radius: 3px;
  background: ${(props) => (props.active ? '#0891b2' : 'rgba(8, 145, 178, 0.22)')};
  cursor: pointer;
  transition: all 0.25s;
`;
const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;
`;
const InfoCard = styled.div`
  background: #ffffff;
  border-radius: 20px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding: 18px 18px 16px;
  height: 100%;
`;
const InfoCardHeader = styled(RowFlex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;
const InfoCardDate = styled.span`
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: #8fa3bb;
`;
const EmptyState = styled(ColumnFlex)`
  min-height: 156px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 14px 0;
  color: #8fa3bb;
`;
const EmptyOwl = styled.div`
  font-size: 48px;
  line-height: 1;
  animation: ${floatMotion} 3s ease infinite;
`;
const EmptyTitle = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 13px;
  font-weight: 800;
  color: #0891b2;
  margin-top: 4px;
`;
const EmptyLabel = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #8fa3bb;
`;
const ReadingList = styled(ColumnFlex)`
  align-items: stretch;
  gap: 12px;
`;
const ReadingItemCard = styled(RowFlex)`
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 14px;
  background: #f0f9ff;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  cursor: pointer;
  transition: all 0.18s;

  &:hover {
    border-color: rgba(8, 145, 178, 0.25);
    transform: translateX(4px);
  }
`;
const AssignedBookCard = styled(RowFlex)`
  align-items: center;
  gap: 16px;
  padding: 14px;
  min-height: 156px;
  border-radius: 14px;
  background: #f0f9ff;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  cursor: pointer;
  transition: all 0.18s;

  &:hover {
    border-color: rgba(8, 145, 178, 0.25);
    transform: translateX(4px);
  }
`;
const AssignedCoverWrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;
const AssignedCover = styled.img`
  width: 104px;
  height: 138px;
  border-radius: 10px;
  object-fit: cover;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.16);
`;
const AssignedDoneBadge = styled.div`
  position: absolute;
  top: -8px;
  left: -8px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, #10b981, #059669);
  border: 2px solid rgba(255, 255, 255, 0.65);
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-family: 'Baloo 2', sans-serif !important;
  font-size: 6px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.04em;
`;
const AssignedInfo = styled(ColumnFlex)`
  flex: 1;
  min-width: 0;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
`;
const AssignedTitle = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  font-weight: 800;
  color: #0c1a2e;
  line-height: 1.35;
`;
const AssignedMeta = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #4a6380;
`;
const AssignedArrow = styled.button`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  color: #8fa3bb;
  font-size: 22px;
  cursor: pointer;
`;
const ReadingCover = styled.img`
  width: 44px;
  height: 58px;
  border-radius: 8px;
  flex-shrink: 0;
  object-fit: cover;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
`;
const ReadingInfo = styled(ColumnFlex)`
  flex: 1;
  min-width: 0;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
`;
const ReadingTitle = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 800;
  color: #0c1a2e;
  line-height: 1.35;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const ReadingLevel = styled.div`
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  color: #0891b2;
`;
const ReadingBar = styled.div`
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background: #d4ecf7;
  overflow: hidden;
  margin-top: 4px;
`;
const ReadingFill = styled.div`
  width: ${(props) => `${props.percent}%`};
  height: 100%;
  border-radius: 3px;
  background: linear-gradient(90deg, #0891b2, #22d3ee);
`;
const ReadingPercent = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #8fa3bb;
  margin-top: 2px;
`;
const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
`;
const StatCard = styled.div`
  border-radius: 20px;
  padding: 18px 20px;
  background: #ffffff;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
`;
const StatIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  background: ${(props) => props.bg};
  margin-bottom: 12px;
`;
const StatLabel = styled.div`
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  font-weight: 800;
  color: #4a6380;
`;
const StatValue = styled.div`
  margin-top: 6px;
  font-family: 'Baloo 2', sans-serif !important;
  font-size: 28px;
  font-weight: 900;
  color: ${(props) => props.color};
`;
const StatUnit = styled.span`
  font-size: 16px;
`;
const StatNote = styled.div`
  margin-top: 4px;
  font-family: 'Nunito', sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.color};
`;
const Icon = styled.div`
  background-image: url(${(props) => props.url});
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-repeat: no-repeat;
  background-size: ${(props) => props.width} ${(props) => props.height};
  margin: 0 5px;
`;
const MobileTabs = styled(Tabs)`
  width: 100%;
  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-nav-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-tabs-tab {
    flex: 1 1 0;
    justify-content: center;
    padding: 8px 0;
    background-color: #4f4a45;
    border-radius: 12px 12px 0 0;
    margin-right: 0;
    color: #e6d6c2;
    font-weight: 600;
  }
  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 8px;
  }
  .ant-tabs-tab-active {
    background-color: #ffffff;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #7b552f;
  }
  .ant-tabs-ink-bar {
    display: none;
  }
`;
const MobileHomePage = styled.div`
  width: 100%;
  padding: 0 0 calc(148px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const MobileAppHeader = styled(RowFlex)`
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px 14px;
  background: linear-gradient(135deg, #0c1a2e 0%, #1e3a5f 60%, #0891b2 100%);
  position: sticky;
  top: 0;
  z-index: 130;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
    background-size: 18px 18px;
    pointer-events: none;
  }
`;
const MobileHeaderBrand = styled(RowFlex)`
  position: relative;
  z-index: 1;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;
const MobileHeaderOwl = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 14px;
  background: linear-gradient(135deg, #0891b2, #06b6d4);
  background-image: url('/images/LevelUp/levelup_owl.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.4);
  flex-shrink: 0;
`;
const MobileHeaderName = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 18px;
  font-weight: 900;
  color: #ffffff;
  line-height: 1;

  span {
    color: #22d3ee;
  }
`;
const MobileHeaderActions = styled(RowFlex)`
  position: relative;
  z-index: 1;
  gap: 8px;
  align-items: center;
`;
const MobileHeaderRound = styled.button`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 0;
`;
const MobileHeroCard = styled.div`
  margin: 0 12px;
  border-radius: 24px;
  background: linear-gradient(135deg, #0891b2 0%, #06b6d4 52%, #06d6a0 100%);
  box-shadow: 0 10px 24px rgba(8, 145, 178, 0.18);
  padding: 18px 18px 16px;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.08) 1px, transparent 1px);
    background-size: 16px 16px;
    pointer-events: none;
  }
`;
const MobileHeroTop = styled(RowFlex)`
  position: relative;
  z-index: 1;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
`;
const MobileHeroHello = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
`;
const MobileHeroName = styled.div`
  margin-top: 2px;
  font-family: 'Baloo 2', sans-serif;
  font-size: 20px;
  font-weight: 900;
  color: #ffffff;
  line-height: 1.15;
`;
const MobileHeroStreak = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.18);
  border: 1.5px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 800;
  color: #ffffff;
  flex-shrink: 0;
`;
const MobileHeroStats = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
`;
const MobileHeroStat = styled.div`
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  padding: 10px 8px;
  text-align: center;
`;
const MobileHeroStatNum = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: ${({ $clickable }) => ($clickable ? '10px' : '20px')};
  font-weight: 900;
  color: #ffffff;
  line-height: 1;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${({ $clickable }) => ($clickable ? '100%' : 'auto')};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
`;
const MobileHeroStatLabel = styled.div`
  font-size: 9px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.65);
  margin-top: 2px;
  letter-spacing: 0.04em;
`;
const MobileQuickActions = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  padding: 0 12px;
`;
const MobileQuickItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
`;
const MobileQuickIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  background: ${(props) => props.$bg || '#ffffff'};
  border: 1.5px solid rgba(8, 145, 178, 0.12);
`;
const MobileQuickLabel = styled.div`
  font-size: 10px;
  font-weight: 800;
  color: #4a6380;
  text-align: center;
  line-height: 1.3;
`;
const MobileContent = styled.div`
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const MobileSectionCard = styled.div`
  background: #ffffff;
  border-radius: 18px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding: 14px;
`;
const MobileSectionHeader = styled(RowFlex)`
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;
const MobileSectionTitle = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #0c1a2e;
  display: flex;
  align-items: center;
  gap: 6px;
`;
const MobileSectionMore = styled.button`
  padding: 4px 10px;
  border-radius: 20px;
  background: rgba(8, 145, 178, 0.1);
  border: 1px solid rgba(8, 145, 178, 0.22);
  color: #0891b2;
  font-size: 12px;
  font-weight: 700;
`;
const MobileHorizontalScroll = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 6px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
`;
const MobileMiniBook = styled.button`
  background: #ffffff;
  border-radius: 18px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  overflow: hidden;
  flex-shrink: 0;
  width: 120px;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding: 0;
  text-align: left;
`;
const MobileMiniThumb = styled.div`
  width: 100%;
  aspect-ratio: 3 / 4;
  position: relative;
  overflow: hidden;
`;
const MobileMiniImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const MobileMiniGrad = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, transparent 40%, rgba(0, 0, 0, 0.6) 100%);
`;
const MobileMiniLevel = styled.div`
  position: absolute;
  bottom: 5px;
  left: 5px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 8px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 20px;
  background: rgba(8, 145, 178, 0.88);
  color: #ffffff;
`;
const MobileMiniHeart = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  background: ${(props) => (props.$active ? '#fee2e2' : 'rgba(255,255,255,.92)')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  padding: 0;
`;
const MobileMiniDone = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(16, 185, 129, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 7px;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 0.04em;
`;
const MobileMiniBody = styled.div`
  padding: 8px 10px 10px;
`;
const MobileMiniTitle = styled.div`
  font-size: 11px;
  font-weight: 800;
  color: #0c1a2e;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const MobileAssignedItem = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: 80px 1fr;
  gap: 12px;
  background: #ffffff;
  border-radius: 14px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
  padding: 0;
  text-align: left;
  margin-bottom: 8px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: #0891b2;
  }
`;
const MobileAssignedThumb = styled.img`
  width: 80px;
  height: 100px;
  object-fit: cover;
`;
const MobileAssignedInfo = styled.div`
  padding: 10px 12px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
`;
const MobileAssignedTitle = styled.div`
  font-size: 12.5px;
  font-weight: 900;
  color: #0c1a2e;
  line-height: 1.3;
`;
const MobileAssignedAuthor = styled.div`
  font-size: 10.5px;
  font-weight: 700;
  color: #0891b2;
`;
const MobileAssignedMeta = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
`;
const MobileAssignedChip = styled.span`
  font-family: 'JetBrains Mono', monospace;
  font-size: 8.5px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 20px;
  background: #f0f9ff;
  border: 1px solid rgba(8, 145, 178, 0.12);
  color: #4a6380;
`;
const MobileEmptyBox = styled.div`
  min-height: 120px;
  border-radius: 18px;
  border: 1.5px dashed rgba(8, 145, 178, 0.18);
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  font-family: 'Baloo 2', sans-serif;
  font-size: 20px;
  font-weight: 700;
`;
const MobileStatRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
`;
const MobileStatCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  border: 1.5px solid rgba(8, 145, 178, 0.12);
  padding: 12px 10px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(8, 145, 178, 0.12);
`;
const MobileStatIcon = styled.div`
  font-size: 20px;
  margin-bottom: 4px;
`;
const MobileStatValue = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: ${(props) => props.$color || '#0891b2'};
  line-height: 1;
`;
const MobileStatLabel = styled.div`
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8fa3bb;
  margin-top: 3px;
`;
const MobilePointHero = styled.div`
  background: linear-gradient(135deg, #f97316, #ea580c);
  border-radius: 18px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 6px 20px rgba(249, 115, 22, 0.3);
  color: #ffffff;
`;
const MobilePointNum = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 40px;
  font-weight: 900;
  line-height: 1;
`;
const MobilePointTrack = styled.div`
  height: 8px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 8px;
`;
const MobilePointFill = styled.div`
  height: 100%;
  width: ${(props) => `${Math.min(100, props.$percent)}%`};
  background: #ffffff;
  border-radius: 4px;
`;
const MobileRankList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const MobileRankItem = styled.div`
  display: grid;
  grid-template-columns: 34px 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(8, 145, 178, 0.12);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;
const MobileRankBadge = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background: ${(props) => props.$bg || '#eaf7fb'};
`;
const MobileRankName = styled.div`
  font-size: 12px;
  font-weight: 800;
  color: #0c1a2e;
`;
const MobileRankBooks = styled.div`
  font-size: 11px;
  font-weight: 900;
  color: #0891b2;
  background: #eaf7fb;
  border-radius: 999px;
  padding: 4px 10px;
`;
const MobileBottomNav = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  background: #ffffff;
  border-top: 1.5px solid rgba(8, 145, 178, 0.12);
  box-shadow: 0 -4px 20px rgba(8, 145, 178, 0.1);
  margin-top: 0;
  padding-bottom: env(safe-area-inset-bottom, 0px);
  z-index: 120;
`;
const MobileBottomNavItem = styled.button`
  padding: 10px 4px 8px;
  border: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: ${(props) => (props.$active ? '#0891b2' : '#8fa3bb')};
  font-size: 10px;
  font-weight: 700;
`;
const MobilePageShell = styled.div`
  width: 100%;
  padding: 0 12px calc(108px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
const MobileRankHero = styled.div`
  margin: 0 12px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f59e0b, #f97316);
  padding: 20px 18px;
  text-align: center;
  color: #ffffff;
  box-shadow: 0 6px 20px rgba(249, 115, 22, 0.3);
`;
const MobileRankHeroTitle = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 22px;
  font-weight: 900;
  margin-bottom: 6px;
`;
const MobileRankHeroSub = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
`;
const MobileRankTabs = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
`;
const MobileRankTabButton = styled.button`
  height: 42px;
  border-radius: 999px;
  border: 1.5px solid ${(props) => (props.$active ? 'rgba(8,145,178,.35)' : 'rgba(143,163,187,.2)')};
  background: ${(props) => (props.$active ? 'linear-gradient(135deg,#0ea5e9,#22c55e)' : '#ffffff')};
  color: ${(props) => (props.$active ? '#ffffff' : '#0c1a2e')};
  font-size: 13px;
  font-weight: 800;
  box-shadow: ${(props) => (props.$active ? '0 8px 18px rgba(14,165,233,.18)' : 'none')};
`;
const MobilePodiumRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 14px;
  padding: 18px 12px 8px;
`;
const MobilePodiumItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;
const MobilePodiumAvatar = styled.div`
  width: ${(props) => props.$size || 58}px;
  height: ${(props) => props.$size || 58}px;
  border-radius: 50%;
  background: ${(props) => props.$bg || 'linear-gradient(135deg,#c0c8d8,#8a96a8)'};
  border: 3px solid rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;
const MobilePodiumBar = styled.div`
  width: 60px;
  height: ${(props) => props.$height || 45}px;
  border-radius: 10px 10px 0 0;
  background: ${(props) => props.$bg || 'linear-gradient(180deg,#c0c8d8,#8a96a8)'};
`;
const MobileProfileHero = styled.div`
  background: linear-gradient(140deg, #0c1a2e 0%, #1e3a5f 50%, #0891b2 100%);
  border-radius: 20px;
  padding: 20px 18px;
  position: relative;
  overflow: hidden;
  color: #ffffff;
`;
const MobileProfileTop = styled(RowFlex)`
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 14px;
  position: relative;
  z-index: 1;
`;
const MobileProfileAvatar = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: 3px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  flex-shrink: 0;
`;
const MobileProfileName = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.15;
`;
const MobileProfileId = styled.div`
  font-family: 'JetBrains Mono', monospace;
  font-size: 10.5px;
  color: rgba(255, 255, 255, 0.55);
  margin-top: 2px;
`;
const MobileProfileGrade = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 3px;
`;
const MobileProfileLexileRow = styled(RowFlex)`
  align-items: center;
  gap: 10px;
  position: relative;
  z-index: 1;
`;
const MobileProfileLexileValue = styled.div`
  font-family: 'Baloo 2', sans-serif;
  font-size: ${({ $clickable }) => ($clickable ? '15px' : '28px')};
  font-weight: 900;
  color: #ffffff;
  line-height: 1;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
`;
const MobileProfileBadge = styled.div`
  margin-left: auto;
  padding: 8px 16px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.15);
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  font-family: 'Baloo 2', sans-serif;
  font-size: 24px;
  font-weight: 900;
  color: #ffffff;
  text-align: center;
`;

const ImgButton = styled.div`
  cursor: pointer;
  width: ${({ heightScale }) => `${43 * heightScale}px`} !important;
  height: ${({ heightScale }) => `${43 * heightScale}px`} !important;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ heightScale }) => `${10 * heightScale}px`};
  background-image: url(${(props) => props.src});
  background-size: contain;
  background-repeat: no-repeat;
`;

function LevelUpGuideVideo() {
  const guideVideosForAfterSchool = useSelector((state) => state.jsonData.guideVideosForAfterSchool);
  if (!guideVideosForAfterSchool?.pturnLevelUp?.[0]?.videos) return null;
  return (
    <div style={{ marginRight: 20 }}>
      <VimeoVideo width={35} marginTop={14} thumpImage="/images/guide.png" item={guideVideosForAfterSchool.pturnLevelUp[0]?.videos} />
    </div>
  );
}
const useCheckScreen = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const handleWindowSizeChange = () => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return [width > 1600 ? 1 : width / 1600, height > 900 ? 1 : height / 900];
};
export default function LevelUpHome() {
  let width = useCheckScreen()[0];
  let height = useCheckScreen()[1];
  const [userData, setUserData] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [currentLevel, setCurrentLevel] = useState(null);
  const [books, setBooks] = useState([]);
  const [error, setError] = useState(null);
  const [currentAssignIndx, setCurrentAssignIndx] = useState(0);
  const [recommendedPage, setRecommendedPage] = useState(0);
  const [rankToggle, setRankToggle] = useState(null);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [mobilePage, setMobilePage] = useState('home');
  const [mobileRankTab, setMobileRankTab] = useState('all');
  const wrapperRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { company_name, type } = userInfoVar();
  const lexileLevel = typeof userData?.lexile_level === 'string' ? userData.lexile_level.trim() : userData?.lexile_level;
  const hasLexileLevel = lexileLevel !== undefined && lexileLevel !== null && lexileLevel !== '';
  const renderLexileValue = (ValueComponent) => {
    if (hasLexileLevel) {
      return (
        <ValueComponent>
          <Tooltip title={`${lexileLevel || ''}`}>{`My Lexile: ${lexileLevel}`}</Tooltip>
        </ValueComponent>
      );
    }

    if (userData?.levelup_test_type) {
      return (
        <ValueComponent $clickable onClick={() => history.push('/level-up/level-test')}>
          Take Level Test
        </ValueComponent>
      );
    }

    return null;
  };
  const [favBook] = useMutation(FAVORITE_BOOK, {
    onCompleted: () => {
      getHandleData();
    },
    onError: (res) => {
      console.log(res);
      alert(res.message);
    },
  });

  useEffect(() => {
    const fontLinkId = 'levelup-elibrary-fonts';
    if (document.getElementById(fontLinkId)) {
      return undefined;
    }

    const link = document.createElement('link');
    link.id = fontLinkId;
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800;900&family=Baloo+2:wght@700;800;900&family=JetBrains+Mono:wght@500;600&display=swap';
    document.head.appendChild(link);

    return () => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    };
  }, []);

  useEffect(() => {
    if (!(window.isNativeAppMobile || isMobileOnly)) return;
    const params = new URLSearchParams(location.search);
    const nextMobilePage = params.get('mobilePage');
    if (nextMobilePage === 'ranking' || nextMobilePage === 'profile' || nextMobilePage === 'home') {
      setMobilePage(nextMobilePage);
      if (nextMobilePage !== 'ranking') {
        setMobileRankTab('all');
      }
    } else {
      setMobilePage('home');
    }
  }, [location.search]);

  const subdomain = useMemo(() => {
    if (window.location.hostname) {
      return window.location.hostname.split('.')[0];
    }
    return 'default';
  }, []);
  let getUserType = GET_STUDENT_LUPUSER;
  if (userInfoVar() && type !== '0' && type !== 0) {
    getUserType = GET_TEACHER_USER;
  }

  const getLatestClassLevel = (classes = []) => {
    const latestClass = _.orderBy(
      classes.filter((classInfo) => classInfo?.levelup_level),
      [
        (classInfo) => {
          const beginDate = moment(classInfo?.begin_date);
          return beginDate.isValid() ? beginDate.valueOf() : 0;
        },
      ],
      ['desc'],
    )[0];

    return latestClass?.levelup_level || '';
  };

  useQuery(getUserType, {
    variables: {},
    onCompleted: (data) => {
      if (data?.getUserData) {
        let tempData = data?.getUserData;
        if (tempData.class_teacher) {
          tempData = Object.assign({}, tempData, { classes: tempData.class_teacher.map((i) => i.class) });
        } else {
          tempData = Object.assign({}, tempData, { classes: tempData.class_student.map((i) => i.class) });
        }

        if (tempData?.user_levelup_tests?.length > 0) {
          const sortedTests = _.orderBy(
            tempData.user_levelup_tests.filter((e) => e.level),
            ['test_end_date'],
            ['desc'],
          );
          // console.log(sortedTests);

          const latestTest = sortedTests[0];
          if (latestTest?.lexile && latestTest?.level) {
            setCurrentLevel(latestTest.level);
            setUserData(tempData);
          } else {
            setCurrentLevel(getLatestClassLevel(tempData?.classes));
            setUserData(tempData);
          }
        } else {
          setCurrentLevel(getLatestClassLevel(tempData?.classes));
          setUserData(tempData);
        }
      }
    },
  });
  // const currentPath = history.location.pathname;

  // const isPathElibrary = currentPath.includes('/e-booklibrary');
  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const {
    data: rankingData,
    refetch: rankingRefetch,
    loading: rankingLoading,
  } = useQuery(EXTERNAL_STUDY_RANKING_LIST, {
    variables: {
      company_idx: userInfoVar()?.campus?.company?.idx,
      campus_idx: rankToggle === 'current' ? userInfoVar()?.campus_idx : null,
      type: 'levelup',
      // start: `2023-09-01`,
      // end: `2023-09-30`,
      start: `${moment(firstDay).format('YYYY-MM-DD')}`,
      end: `${moment(lastDay).format('YYYY-MM-DD')}`,
    },
    // skip: !isPathElibrary,
  });
  const { data: dailyExternalStudyScheduleList } = useQuery(GET_DAILY_EXTERNAL_STUDY_SCHEDULE_DUE, {
    fetchPolicy: 'no-cache',
    variables: {
      user_idx: parseInt(userInfoVar()?.idx),
      date_string: moment().format('YYYY-MM-DD'),
      type: 'levelup',
      check_due: true,
    },
  });
  const { data: pointdata, loading: pointLoading } = useQuery(LEVEL_UP_POINT, {
    variables: {
      user_idx: parseInt(userInfoVar()?.idx),
    },
    fetchPolicy: 'no-cache',
    skip: !userInfoVar()?.idx,
  });
  const levelupPoint = useMemo(() => {
    if (pointdata) {
      const points = pointdata.getLevelupPoints;
      const monthly = points.month.reduce((acc, cur) => acc + parseInt(cur.points), 0);
      function roundToNearest(value) {
        if (value === 0) {
          return 100;
        } else if (value < 1000) {
          return Math.ceil(value / 100) * 100;
        } else if (value < 10000) {
          return Math.ceil(value / 1000) * 1000;
        } else {
          return Math.ceil(value / 10000) * 10000;
        }
      }
      return { monthly: monthly, goal: roundToNearest(monthly) };
    }
    return { monthly: 0, goal: 100 };
  }, [pointdata]);
  const ranking = useMemo(() => {
    if (rankingData?.externalStudyRankingList) {
      const tmp = _.cloneDeep(rankingData?.externalStudyRankingList);
      tmp.sort((a, b) => {
        if (a.book_count === b.book_count) {
          return a.user_name.localeCompare(b.user_name);
        } else {
          return b.book_count - a.book_count;
        }
      });
      let rank = 1;
      let same = 1;
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].rank = rank;

        if (i < tmp.length - 1) {
          if (tmp[i].book_count !== tmp[i + 1].book_count) {
            rank = rank + same;
            same = 1;
          } else {
            same++;
          }
        }
      }
      return tmp;
    }
    return [];
  }, [rankingData]);
  // Temporary hardcoded point detail rows for the e-Library right panel.
  const pointDetailItems = [
    { label: '?ㅻ뒛 1沅??쎄린', value: '+5pt', background: 'rgba(16, 185, 129, 0.12)', color: '#10b981' },
    { label: '遺곷━?ы듃 ?묒꽦', value: '+10pt', background: 'rgba(139, 92, 246, 0.12)', color: '#8b5cf6' },
    { label: '異쒖꽍 泥댄겕', value: '+4pt', background: 'rgba(249, 115, 22, 0.12)', color: '#f97316' },
  ];
  const handleRankToggle = (source) => {
    if (rankToggle === source) {
      setRankToggle(null);
    } else {
      setRankToggle(source);
    }
  };
  useEffect(() => {
    if (!(window.isNativeAppMobile || isMobileOnly)) return;
    if (mobilePage !== 'ranking') return;
    setRankToggle(mobileRankTab === 'school' ? 'current' : 'fc');
  }, [mobilePage, mobileRankTab]);
  const handleMobileSearchToggle = () => {
    const nextOpen = !mobileSearchOpen;
    setMobileSearchOpen(nextOpen);
    if (nextOpen) {
      wrapperRef.current?.scrollTo?.({ top: 0, behavior: 'smooth' });
      window.scrollTo?.({ top: 0, behavior: 'smooth' });
    }
  };
  const user_idx = userInfoVar()?.idx || null;
  const currentMonth = moment().format('YYYY-MM');
  const previousMonth = moment().subtract(1, 'month').format('YYYY-MM');
  const {
    data: recentReadingData,
    loading: loadingRecent,
    refetch: refetchLast,
  } = useQuery(EXTERNAL_USER_STUDY_LEVELUP, {
    variables: {
      user_idx: parseInt(user_idx),
      ym: moment().format('YYYY-MM'),
      type: 'levelup',
      status: 1,
      limit: 2,
    },
    fetchPolicy: 'no-cache',
    skip: !user_idx,
  });
  const { data: currentMonthCompletedData } = useQuery(EXTERNAL_USER_STUDY_LEVELUP, {
    variables: {
      user_idx: parseInt(user_idx),
      ym: currentMonth,
      type: 'levelup',
      status: 2,
    },
    fetchPolicy: 'no-cache',
    skip: !user_idx,
  });
  const { data: previousMonthCompletedData } = useQuery(EXTERNAL_USER_STUDY_LEVELUP, {
    variables: {
      user_idx: parseInt(user_idx),
      ym: previousMonth,
      type: 'levelup',
      status: 2,
    },
    fetchPolicy: 'no-cache',
    skip: !user_idx,
  });
  const {
    data: userBook,
    loading,
    refetch,
  } = useQuery(EXTERNAL_STUDY_BOOK, {
    variables: {
      orderBy: 'likes',
      type: 'levelup',
      take: 8,
      page: 1,
      level: currentLevel || null,
    },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    refetch();
  }, [user_idx]);

  const lastReadBook = useMemo(() => {
    if (recentReadingData?.getExternalStuiesList?.length > 0) {
      let assignedData = recentReadingData?.getExternalStuiesList[0];
      let book = assignedData?.article_data
        ? JSON.parse(assignedData?.article_data)
        : {
            lexileScore: '',
            issue_date: '',
            title: '',
            level: '',
            image: '',
          };
      book.image = `https://cdn.cloubot.com/LEVELUP/covers/${book?.code}.png`;
      book.level = book?.mx_level;

      // let filterBook = userBook?.getExternalUserBook?.filter((f) => f.book_id === book.book_no);
      // book.fav_cnt = filterBook.length > 0 ? filterBook[0].fav_cnt : 0;
      // book.is_fav = filterBook.length > 0 ? filterBook[0].is_fav : 0;

      // console.log(book);

      return {
        ...book,
        selfStudy: assignedData?.assigned_idx === null,
        assigned_idx: assignedData?.assigned_idx,
        is_fav: assignedData?.is_fav,
      };
    } else {
      return null;
    }
  }, [recentReadingData]);
  const assignedBooks = useMemo(() => {
    if (dailyExternalStudyScheduleList?.dailyExternalStudySchedule?.length > 0) {
      return dailyExternalStudyScheduleList?.dailyExternalStudySchedule.map((e) => {
        let book = e?.external_study_data
          ? JSON.parse(e?.external_study_data)
          : {
              lexileScore: '',
              issue_date: '',
              title: '',
              level: '',
              image: '',
            };

        book.image = `https://cdn.cloubot.com/LEVELUP/covers/${book?.code}.png`;
        book.level = book?.mx_level;

        return {
          ...book,
          is_done: e?.is_done,
          assigned_date: e?.start_date,
          assigned_idx: e?.idx,
          external_study_idx: e?.external_study_idx,
          selfStudy: e?.assigned_idx === null,
        };
      });
    } else {
      return [];
    }
  }, [dailyExternalStudyScheduleList]);
  const getHandleData = () => {
    refetch();
  };
  const handleToggleFavorite = async (e, book) => {
    e.preventDefault();
    e.stopPropagation();
    if (!book?.book_no) return;
    await favBook({ variables: { book_id: book.book_no, type: 'levelup' } });
  };
  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };
  const handleSearch = () => {
    if (searchValue.length > 1) {
      {
        history.push(`/level-up/search?myLevel=${currentLevel === 'PH' ? 0 : parseInt(currentLevel)}&keyword=${searchValue}`);
      }
    } else {
      alert('Please write a search term of at least 2 characters.');
    }
  };
  const setMxLevel = (lexile) => {
    const mx = getLixileScoreObject(lexile, 'A-1');
    return mx;
  };
  const setLexileValue = (lexile) => {
    if (lexile.includes('BR')) {
      return 0;
    } else if (lexile.includes('NP')) {
      return 1000;
    } else {
      return parseInt(lexile);
    }
  };
  useEffect(() => {
    try {
      if (userBook?.getExternalUserBook?.length) {
        let list = userBook?.getExternalUserBook?.map((e, i) => {
          e.no = i + 1;
          e.lexileVal = e.lexile_val ? e.lexile_val : setLexileValue(e.lexile);
          e.mxObj = setMxLevel(e.lexileVal);
          e.level = e.mxObj?.mx;
          return e;
        });
        setBooks(list);
      }
    } catch (e) {
      setError(e);
    }
  }, [userBook]);
  const handleNextAssigned = () => {
    if (assignedBooks.length === currentAssignIndx + 1) {
      setCurrentAssignIndx(0);
    } else setCurrentAssignIndx(currentAssignIndx + 1);
  };
  const parsedCurrentLevel = currentLevel === 'PH' ? 0 : parseInt(currentLevel, 10);
  const normalizedCurrentLevel = useMemo(() => {
    if (currentLevel === 'PH') return 0;
    const parsedLevel = parseInt(currentLevel, 10);
    return Number.isNaN(parsedLevel) ? null : parsedLevel;
  }, [currentLevel]);
  const formatMxLevel = (levelValue) => {
    if (levelValue === 'PH' || levelValue === 0) return 'PH';
    if (levelValue === null || levelValue === undefined || levelValue === '') return '--';
    return String(levelValue).padStart(2, '0');
  };
  const formatLexile = (lexileValue) => {
    if (_.isNil(lexileValue) || lexileValue === '') return '-';
    const numericValue = parseInt(lexileValue, 10);
    if (Number.isNaN(numericValue)) return `${lexileValue}`;
    return numericValue < 0 ? `BR${Math.abs(numericValue)}L` : `${numericValue}L`;
  };
  const recommendedBooks = useMemo(() => books.slice(0, 8), [books]);
  const recommendedPageSize = width <= 0.72 ? 2 : width <= 0.82 ? 3 : 4;
  const recommendedPageCount = Math.max(1, Math.ceil(recommendedBooks.length / recommendedPageSize));
  const visibleRecommendedBooks = useMemo(() => {
    const startIndex = recommendedPage * recommendedPageSize;
    return recommendedBooks.slice(startIndex, startIndex + recommendedPageSize);
  }, [recommendedBooks, recommendedPage, recommendedPageSize]);
  useEffect(() => {
    setRecommendedPage((prev) => Math.min(prev, Math.max(recommendedPageCount - 1, 0)));
  }, [recommendedPageCount]);
  const recommendedLevelValue = normalizedCurrentLevel ?? recommendedBooks[0]?.level ?? 1;
  const recommendedBadgeText = useMemo(() => {
    const badgeLevel = normalizedCurrentLevel ?? recommendedBooks[0]?.level;
    const badgeLexile = normalizedCurrentLevel !== null ? MXLEVEL_TO_LEXILE[currentLevel] : formatLexile(recommendedBooks[0]?.lexileVal);
    return `mx ${formatMxLevel(badgeLevel)} · ${badgeLexile || '-'}`;
  }, [normalizedCurrentLevel, recommendedBooks, currentLevel]);

  const readingBooks = useMemo(() => {
    return (recentReadingData?.getExternalStuiesList || []).slice(0, 2).map((studyItem) => {
      const bookData = studyItem?.article_data ? JSON.parse(studyItem.article_data) : {};
      const completedStages = _.uniq(
        (studyItem?.external_study_stage || [])
          .map((stage) => parseInt(stage?.stage_no, 10))
          .filter((stageNo) => [1, 2, 3, 4, 5].includes(stageNo)),
      );
      const progress = Math.min(100, Math.round((completedStages.length / 5) * 100));
      return {
        ...studyItem,
        ...bookData,
        code: bookData?.code,
        title: bookData?.title,
        image: `https://cdn.cloubot.com/LEVELUP/covers/${bookData?.code}.png`,
        level: bookData?.mx_level,
        lexileVal: !_.isNil(bookData?.lexile_val) ? bookData?.lexile_val : setLexileValue(bookData?.lexile || ''),
        progress,
      };
    });
  }, [recentReadingData]);
  const currentMonthCompletedList = useMemo(() => currentMonthCompletedData?.getExternalStuiesList || [], [currentMonthCompletedData]);
  const previousMonthCompletedList = useMemo(() => previousMonthCompletedData?.getExternalStuiesList || [], [previousMonthCompletedData]);
  const getStudyAttendanceCount = (studyList = []) =>
    new Set(studyList.map((item) => item?.last_study_timestamp?.slice(8, 10)).filter(Boolean)).size;
  const attendanceStreakDays = useMemo(() => {
    const studyDates = new Set(
      [...currentMonthCompletedList, ...previousMonthCompletedList].map((item) => item?.last_study_timestamp?.slice(0, 10)).filter(Boolean),
    );
    const cursor = moment().subtract(1, 'day').startOf('day');
    let count = 0;

    while (studyDates.has(cursor.format('YYYY-MM-DD'))) {
      count += 1;
      cursor.subtract(1, 'day');
    }

    return count;
  }, [currentMonthCompletedList, previousMonthCompletedList]);
  const getStudyTimeMs = (studyList = []) => {
    return studyList.reduce((acc, studyEle) => {
      const last = studyEle?.last_study_timestamp?.slice(0, 19);
      if (!last) return acc;

      const first = _.sortBy(
        (studyEle?.external_study_stage || [])
          .map((stage) => stage?.study_date?.slice(0, 19))
          .filter((value) => value && value.includes(last.slice(0, 10))),
        (value) => new moment(value),
      )[0];

      if (!first) return acc;
      const diff = moment(last).diff(moment(first));
      return Number.isNaN(diff) ? acc : acc + diff;
    }, 0);
  };
  const formatReadingTime = (timeMs) => {
    const duration = moment.duration(timeMs);
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    if (hours > 0) return `${hours}시간 ${minutes}분`;
    return `${minutes}분`;
  };
  const currentMonthAttendanceCount = useMemo(() => getStudyAttendanceCount(currentMonthCompletedList), [currentMonthCompletedList]);
  const previousMonthAttendanceCount = useMemo(() => getStudyAttendanceCount(previousMonthCompletedList), [previousMonthCompletedList]);
  const currentMonthReadingTimeMs = useMemo(() => getStudyTimeMs(currentMonthCompletedList), [currentMonthCompletedList]);
  const todayReadingTimeMs = useMemo(
    () =>
      getStudyTimeMs(
        currentMonthCompletedList.filter((studyItem) => studyItem?.last_study_timestamp?.slice(0, 10) === moment().format('YYYY-MM-DD')),
      ),
    [currentMonthCompletedList],
  );
  const todayReadingNote = useMemo(() => {
    if (todayReadingTimeMs > 0) return `오늘 ${formatReadingTime(todayReadingTimeMs)} 읽었어요`;
    return '오늘 읽은 도서가 없어요';
  }, [todayReadingTimeMs]);
  const attendanceCompareMessage = useMemo(() => {
    const diff = currentMonthAttendanceCount - previousMonthAttendanceCount;
    if (diff > 0) return `지난달보다 ${diff}일 더 출석했어요`;
    if (diff < 0) return `지난달보다 ${Math.abs(diff)}일 덜 출석했어요`;
    return '지난달과 출석일이 같아요';
  }, [currentMonthAttendanceCount, previousMonthAttendanceCount]);
  const statsCards = useMemo(
    () => [
      {
        icon: '📅',
        label: '이번달 출석',
        value: currentMonthAttendanceCount,
        unit: '일',
        note: attendanceCompareMessage,
        color: '#0891b2',
        noteColor:
          currentMonthAttendanceCount > previousMonthAttendanceCount
            ? '#10b981'
            : currentMonthAttendanceCount < previousMonthAttendanceCount
              ? '#f97316'
              : '#8fa3bb',
        bg: 'rgba(8,145,178,.1)',
      },
      {
        icon: '⏱️',
        label: '읽기시간',
        value: formatReadingTime(currentMonthReadingTimeMs),
        unit: '',
        note: todayReadingNote,
        color: '#f97316',
        noteColor: todayReadingTimeMs > 0 ? '#10b981' : '#8fa3bb',
        bg: 'rgba(249,115,22,.1)',
      },
      {
        icon: '📚',
        label: '완독도서',
        value: currentMonthCompletedList.length,
        unit: '권',
        note: ' ',
        color: '#8b5cf6',
        noteColor: '#8fa3bb',
        bg: 'rgba(139,92,246,.1)',
      },
    ],
    [
      attendanceCompareMessage,
      currentMonthAttendanceCount,
      currentMonthCompletedList.length,
      currentMonthReadingTimeMs,
      previousMonthAttendanceCount,
      todayReadingNote,
      todayReadingTimeMs,
    ],
  );
  const handleLibraryViewAll = () => {
    const targetLevel = normalizedCurrentLevel ?? recommendedBooks[0]?.level ?? 1;
    history.push(`/level-up/library?lv=${targetLevel}`);
  };
  const handleRecommendedPageMove = (direction) => {
    if (recommendedPageCount <= 1) return;
    setRecommendedPage((prev) => {
      if (direction > 0) {
        return prev === recommendedPageCount - 1 ? 0 : prev + 1;
      }
      return prev === 0 ? recommendedPageCount - 1 : prev - 1;
    });
  };
  const goToReader = (bookData, extraState = {}) => {
    if (!bookData?.code) return;
    history.push(
      `/level-up/${bookData?.is_voca ? 'study' : `${bookData?.is_interactive ? 'epub-' : ''}reader`}/${bookData?.code}`,
      extraState,
    );
  };
  const desktopCenterContent = (
    <CenterScroll>
      <WelcomeBanner>
        <WelcomeLeft>
          <WelcomeGreeting>Welcome Back</WelcomeGreeting>
          <WelcomeName>{`${userData?.name || ''} 학생`}</WelcomeName>
          <WelcomeSub>오늘도 영어책과 함께 멋진 하루를 시작해볼까요?</WelcomeSub>
          <WelcomeChips>
            <WelcomeChip>{`📘 ${currentLevel ? `mx Level ${formatMxLevel(normalizedCurrentLevel)}` : 'mx Level -'}`}</WelcomeChip>
            {currentLevel && <WelcomeChip>{`📖 AGL -${MXLEVEL_TO_AGL[currentLevel]}`}</WelcomeChip>}
            {/* <WelcomeChip>{`🏫 ${userData?.school_grade || ''}`}</WelcomeChip> */}
            {attendanceStreakDays > 0 && <WelcomeChip>{`📅 ${attendanceStreakDays}일 연속 출석!`}</WelcomeChip>}
          </WelcomeChips>
        </WelcomeLeft>
        <WelcomeRight>
          <LexileCircle>
            <LexileCircleValue>{userData?.lexile_level || '-'}</LexileCircleValue>
            <LexileCircleLabel>MY LEXILE</LexileCircleLabel>
          </LexileCircle>
          <WelcomeLevel>{`CLASS LEVEL ${currentLevel === 'PH' ? 'PH' : currentLevel || '-'}`}</WelcomeLevel>
        </WelcomeRight>
      </WelcomeBanner>

      <MainSection>
        <SectionHead>
          <SectionTitleWrap>
            <Title style={{ margin: 0 }}>
              <span>{'\u{2B50}'}</span>
              <span>Recommended Books</span>
            </Title>
            <SectionLevelBadge>{recommendedBadgeText}</SectionLevelBadge>
          </SectionTitleWrap>
          <SectionMore type="button" onClick={handleLibraryViewAll}>
            전체 보기 →
          </SectionMore>
        </SectionHead>
        {loading && <Spin style={{ marginLeft: '10px' }} size="small" />}
        <RecommendedOuter>
          <CarouselNav type="button" onClick={() => handleRecommendedPageMove(-1)} style={{ left: '0' }}>
            ‹
          </CarouselNav>
          <RecommendedGrid $columns={recommendedPageSize}>
            {visibleRecommendedBooks.map((book) => (
              <BookCard key={book.code} onClick={() => history.push(type > 0 && company_name !== 'gnb'
                                  ? `/level-up/description/${book.code}`
                                  : `/level-up/${book?.is_voca ? 'study' : `${book?.is_interactive ? 'epub-' : ''}reader`}/${
                                      book?.code
                                    }`)}>
                <BookCover>
                  <BookCoverImg src={`https://cdn.cloubot.com/LEVELUP/covers/${book?.code}.png`} alt={book?.title} />
                  <BookCoverShade />
                  {book?.is_completed && (
                    <BookDoneBadge>
                      <span style={{ fontSize: '18px', lineHeight: 1 }}>{'\u{2713}'}</span>
                      <span>COMPLETED</span>
                    </BookDoneBadge>
                  )}
                  <BookHeart type="button" $active={!!book?.is_fav} onClick={(event) => handleToggleFavorite(event, book)}>
                    {book?.is_fav ? '❤️' : '🤍'}
                  </BookHeart>
                  <BookMetaTag>{`mx ${formatMxLevel(book?.level)}(${formatLexile(book?.lexileVal)})`}</BookMetaTag>
                </BookCover>
                <BookTitle>{book?.title}</BookTitle>
              </BookCard>
            ))}
          </RecommendedGrid>
          <CarouselNav type="button" onClick={() => handleRecommendedPageMove(1)} style={{ right: '0' }}>
            ›
          </CarouselNav>
        </RecommendedOuter>

        {recommendedPageCount > 1 && (
          <RecommendedDots>
            {Array.from({ length: recommendedPageCount }).map((_, index) => (
              <RecommendedDot key={index} type="button" active={index === recommendedPage} onClick={() => setRecommendedPage(index)} />
            ))}
          </RecommendedDots>
        )}
      </MainSection>

      <InfoRow>
        <InfoCard>
          <InfoCardHeader>
            <SubTitle>
              <span>{'\u{1F4CB}'}</span>
              <span>Assigned Books</span>
            </SubTitle>
            <InfoCardDate>{moment().format('YYYY.MM.DD')}</InfoCardDate>
          </InfoCardHeader>
          {assignedBooks?.length > 0 ? (
            <AssignedBookCard
              onClick={() =>
                goToReader(assignedBooks[currentAssignIndx], {
                  assigned_idx: assignedBooks[currentAssignIndx]?.assigned_idx,
                  external_study_idx: assignedBooks[currentAssignIndx]?.external_study_idx,
                  bookData: assignedBooks[currentAssignIndx],
                })
              }
            >
              <AssignedCoverWrap>
                <AssignedCover src={assignedBooks[currentAssignIndx]?.image} alt={assignedBooks[currentAssignIndx]?.title} />
                {assignedBooks[currentAssignIndx]?.is_done && (
                  <AssignedDoneBadge>
                    <span style={{ fontSize: '15px' }}>{'\u{2713}'}</span>
                    <span>DONE</span>
                  </AssignedDoneBadge>
                )}
              </AssignedCoverWrap>
              <AssignedInfo>
                <AssignedTitle>{assignedBooks[currentAssignIndx]?.title}</AssignedTitle>
                <ReadingLevel>{`mx ${formatMxLevel(assignedBooks[currentAssignIndx]?.mx_level)} • ${formatLexile(
                  assignedBooks[currentAssignIndx]?.lexile_val,
                )}`}</ReadingLevel>
                <AssignedMeta>{`Assigned for ${moment(assignedBooks[currentAssignIndx]?.assigned_date).format('YYYY.MM.DD')}`}</AssignedMeta>
                <ReadingBar>
                  <ReadingFill percent={assignedBooks[currentAssignIndx]?.is_done ? 100 : 40} />
                </ReadingBar>
                <ReadingPercent>{assignedBooks[currentAssignIndx]?.is_done ? '100%' : '40%'}</ReadingPercent>
              </AssignedInfo>
              {assignedBooks?.length > 1 && (
                <AssignedArrow
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleNextAssigned();
                  }}
                >
                  ??
                </AssignedArrow>
              )}
            </AssignedBookCard>
          ) : (
            <EmptyState>
              <EmptyOwl>{'\u{1F989}'}</EmptyOwl>
              <EmptyTitle>Level Up Reader!</EmptyTitle>
              <EmptyLabel>No Assigned Books</EmptyLabel>
            </EmptyState>
          )}
        </InfoCard>

        <InfoCard>
          <InfoCardHeader>
            <SubTitle>
              <span>{'\u{1F4D6}'}</span>
              <span>Currently Reading</span>
            </SubTitle>
          </InfoCardHeader>
          {readingBooks.length > 0 ? (
            <ReadingList>
              {readingBooks.map((book) => (
                <ReadingItemCard
                  key={book?.idx}
                  onClick={() =>
                    goToReader(book, {
                      bookData: book,
                      assigned_idx: book?.assigned_idx || null,
                    })
                  }
                >
                  <ReadingCover src={book?.image} alt={book?.title} />
                  <ReadingInfo>
                    <ReadingTitle>{book?.title}</ReadingTitle>
                    <ReadingLevel>{`mx ${formatMxLevel(book?.level)} · ${formatLexile(book?.lexileVal)}`}</ReadingLevel>
                    <ReadingBar>
                      <ReadingFill percent={book?.progress || 0} />
                    </ReadingBar>
                    <ReadingPercent>{`${book?.progress || 0}%`}</ReadingPercent>
                  </ReadingInfo>
                </ReadingItemCard>
              ))}
            </ReadingList>
          ) : (
            <EmptyState>
              <EmptyOwl>{'\u{1F4D6}'}</EmptyOwl>
              <EmptyLabel>No reading data</EmptyLabel>
            </EmptyState>
          )}
        </InfoCard>
      </InfoRow>

      <StatsRow>
        {statsCards.map((card) => (
          <StatCard key={card.label}>
            <StatIcon bg={card.bg}>{card.icon}</StatIcon>
            <StatLabel>{card.label}</StatLabel>
            <StatValue color={card.color}>
              {card.value}
              <StatUnit>{card.unit}</StatUnit>
            </StatValue>
            <StatNote color={card.noteColor}>{card.note}</StatNote>
          </StatCard>
        ))}
      </StatsRow>
    </CenterScroll>
  );
  const currentUserRank = ranking.find((item) => item.user_name === userData?.name);
  const mobileRankingPeriodText = `${moment().format('YYYY년 M월')} · 이번 달 순위`;
  const mobileHeader = (
    <>
      <MobileAppHeader>
        <MobileHeaderBrand>
          <MobileHeaderOwl />
          <MobileHeaderName>
            e-<span>Library</span>
          </MobileHeaderName>
        </MobileHeaderBrand>
        <MobileHeaderActions>
          <MobileHeaderRound type="button" onClick={handleMobileSearchToggle}>
            {'\u{1F50D}'}
          </MobileHeaderRound>
          <MobileHeaderRound type="button" onClick={() => history.push('/level-up/calendar')}>
            {'\u{1F514}'}
          </MobileHeaderRound>
          <MobileHeaderRound type="button" onClick={() => history.push('/')}>
            {'\u{274C}'}
          </MobileHeaderRound>
        </MobileHeaderActions>
      </MobileAppHeader>
      {mobileSearchOpen && (
        <MobileSearchBar>
          <MobileSearchInput
            onPressEnter={handleSearch}
            onChange={handleInputChange}
            allowClear
            bordered={false}
            placeholder="Search books or keywords"
            suffix={<SearchOutlined onClick={handleSearch} style={{ border: 'none', fontSize: '14px' }} />}
          />
        </MobileSearchBar>
      )}
    </>
  );
  const mobileBottomNav = (
    <MobileBottomNav>
      <MobileBottomNavItem type="button" $active={mobilePage === 'home'} onClick={() => history.push('/level-up?mobilePage=home')}>
        <span>{'\u{1F3E0}'}</span>
        <span>Home</span>
      </MobileBottomNavItem>
      <MobileBottomNavItem type="button" onClick={() => history.push(`/level-up/library?lv=${normalizedCurrentLevel ?? 1}`)}>
        <span>{'\u{1F4DA}'}</span>
        <span>Library</span>
      </MobileBottomNavItem>
      <MobileBottomNavItem type="button" onClick={() => history.push('/level-up/portfolio')}>
        <span>{'\u{1F4C2}'}</span>
        <span>Portfolio</span>
      </MobileBottomNavItem>
      <MobileBottomNavItem type="button" $active={mobilePage === 'ranking'} onClick={() => history.push('/level-up?mobilePage=ranking')}>
        <span>{'\u{1F3C6}'}</span>
        <span>Ranking</span>
      </MobileBottomNavItem>
      <MobileBottomNavItem type="button" $active={mobilePage === 'profile'} onClick={() => history.push('/level-up?mobilePage=profile')}>
        <span>{'\u{1F464}'}</span>
        <span>내 정보</span>
      </MobileBottomNavItem>
    </MobileBottomNav>
  );
  const mobileHomeContent = (
    <MobileHomePage>
      {mobileHeader}

      <MobileHeroCard>
        <MobileHeroTop>
          <div>
            <MobileHeroHello>WELCOME BACK</MobileHeroHello>
            <MobileHeroName>{userData?.name || 'LevelUp Reader'}</MobileHeroName>
          </div>
          <MobileHeroStreak>{'\u{1F525}'} 3일 연속 출석</MobileHeroStreak>
        </MobileHeroTop>
        <MobileHeroStats>
          <MobileHeroStat>
            <MobileHeroStatNum>{userData?.lexile_level || '-'}</MobileHeroStatNum>
            <MobileHeroStatLabel>MY LEXILE</MobileHeroStatLabel>
          </MobileHeroStat>
          <MobileHeroStat>
            <MobileHeroStatNum>{currentLevel === 'PH' ? 'PH' : currentLevel || '-'}</MobileHeroStatNum>
            <MobileHeroStatLabel>CLASS LEVEL</MobileHeroStatLabel>
          </MobileHeroStat>
          <MobileHeroStat>
            <MobileHeroStatNum>{levelupPoint.monthly || 0}</MobileHeroStatNum>
            <MobileHeroStatLabel>MONTHLY POINTS</MobileHeroStatLabel>
          </MobileHeroStat>
        </MobileHeroStats>
      </MobileHeroCard>

      <MobileContent>
        <MobileSectionCard>
          <MobileSectionHeader>
            <MobileSectionTitle>
              <span>{'\u{2B50}'}</span>
              <span>Recommended Books</span>
            </MobileSectionTitle>
            <MobileSectionMore type="button" onClick={handleLibraryViewAll}>
              전체 보기
            </MobileSectionMore>
          </MobileSectionHeader>
          {loading ? (
            <Spin />
          ) : (
            <MobileHorizontalScroll>
              {recommendedBooks.slice(0, 6).map((book) => (
                <MobileMiniBook key={`mobile-rec-${book.code}`} type="button" onClick={() => goToReader(book, { bookData: book })}>
                  <MobileMiniThumb>
                    <MobileMiniImage src={`https://cdn.cloubot.com/LEVELUP/covers/${book?.code}.png`} alt={book?.title} />
                    <MobileMiniGrad />
                    <MobileMiniHeart type="button" $active={!!book?.is_fav} onClick={(event) => handleToggleFavorite(event, book)}>
                      {book?.is_fav ? '❤️' : '🤍'}
                    </MobileMiniHeart>
                    {book.is_completed && (
                      <MobileMiniDone>
                        <span style={{ fontSize: 24, lineHeight: 1 }}>{'\u{2713}'}</span>
                        COMPLETED
                      </MobileMiniDone>
                    )}
                    <MobileMiniLevel>{`mx ${formatMxLevel(book.level)}(${formatLexile(book.lexileVal)})`}</MobileMiniLevel>
                  </MobileMiniThumb>
                  <MobileMiniBody>
                    <MobileMiniTitle>{book?.title}</MobileMiniTitle>
                  </MobileMiniBody>
                </MobileMiniBook>
              ))}
            </MobileHorizontalScroll>
          )}
        </MobileSectionCard>

        <MobileSectionCard>
          <MobileSectionHeader>
            <MobileSectionTitle>
              <span>{'\u{1F4D8}'}</span>
              <span>Assigned Books</span>
            </MobileSectionTitle>
            {assignedBooks.length > 1 && (
              <MobileSectionMore type="button" onClick={handleNextAssigned}>
                다음
              </MobileSectionMore>
            )}
          </MobileSectionHeader>
          {assignedBooks.length ? (
            assignedBooks.slice(0, 2).map((book) => (
              <MobileAssignedItem
                key={`mobile-assigned-${book.code}-${book.assigned_idx}`}
                type="button"
                onClick={() =>
                  goToReader(book, {
                    assigned_idx: book?.assigned_idx,
                    external_study_idx: book?.external_study_idx,
                    bookData: book,
                  })
                }
              >
                <MobileAssignedThumb src={book.image} alt={book.title} />
                <MobileAssignedInfo>
                  <MobileAssignedTitle>{book.title}</MobileAssignedTitle>
                  <MobileAssignedAuthor>{book.author}</MobileAssignedAuthor>
                  <MobileAssignedMeta>
                    <MobileAssignedChip>{`mx ${formatMxLevel(book.mx_level)}`}</MobileAssignedChip>
                    <MobileAssignedChip>{formatLexile(book.lexile_val)}</MobileAssignedChip>
                  </MobileAssignedMeta>
                  <MobileAssignedAuthor>{moment(book.assigned_date).format('YYYY.MM.DD')}</MobileAssignedAuthor>
                </MobileAssignedInfo>
              </MobileAssignedItem>
            ))
          ) : (
            <MobileEmptyBox>{'\u{1F989}'} No Assigned Books</MobileEmptyBox>
          )}
        </MobileSectionCard>

        <MobileStatRow>
          {statsCards.map((card) => (
            <MobileStatCard key={card.label}>
              <MobileStatIcon>{card.icon}</MobileStatIcon>
              <MobileStatValue $color={card.color}>{card.value}</MobileStatValue>
              <MobileStatLabel>{card.label}</MobileStatLabel>
            </MobileStatCard>
          ))}
        </MobileStatRow>
      </MobileContent>

      {mobileBottomNav}
    </MobileHomePage>
  );
  const mobileRankingContent = (
    <MobileHomePage>
      {mobileHeader}
      <MobilePageShell>
        <MobileRankHero>
          <MobileRankHeroTitle>{'\u{1F3C6}'} School Ranking</MobileRankHeroTitle>
          <MobileRankHeroSub>{mobileRankingPeriodText}</MobileRankHeroSub>
        </MobileRankHero>
        <MobileRankTabs>
          <MobileRankTabButton type="button" $active={mobileRankTab === 'all'} onClick={() => setMobileRankTab('all')}>
            All School
          </MobileRankTabButton>
          <MobileRankTabButton type="button" $active={mobileRankTab === 'school'} onClick={() => setMobileRankTab('school')}>
            My School
          </MobileRankTabButton>
        </MobileRankTabs>
        <MobileSectionCard>
          <MobilePodiumRow>
            {[
              ranking.find((item) => item.rank === 2) || { rank: 2, user_name: '-' },
              ranking.find((item) => item.rank === 1) || { rank: 1, user_name: '-' },
              ranking.find((item) => item.rank === 3) || { rank: 3, user_name: '-' },
            ].map((item) => (
              <MobilePodiumItem key={`podium-${item.rank}`}>
                <MobilePodiumAvatar
                  $size={item.rank === 1 ? 68 : 56}
                  $bg={
                    item.rank === 1
                      ? 'linear-gradient(135deg,#facc15,#f97316)'
                      : item.rank === 2
                        ? 'linear-gradient(135deg,#94a3b8,#cbd5e1)'
                        : 'linear-gradient(135deg,#b45309,#fb923c)'
                  }
                >
                  {item.rank === 1 ? '\u{1F947}' : item.rank === 2 ? '\u{1F948}' : '\u{1F949}'}
                </MobilePodiumAvatar>
                <div style={{ fontSize: 12, fontWeight: 800 }}>{item.user_name || `Rank ${item.rank}`}</div>
                <MobilePodiumBar
                  $height={item.rank === 1 ? 82 : item.rank === 2 ? 58 : 48}
                  $bg={
                    item.rank === 1
                      ? 'linear-gradient(180deg,#facc15,#f97316)'
                      : item.rank === 2
                        ? 'linear-gradient(180deg,#94a3b8,#cbd5e1)'
                        : 'linear-gradient(180deg,#b45309,#fb923c)'
                  }
                />
              </MobilePodiumItem>
            ))}
          </MobilePodiumRow>
        </MobileSectionCard>
        <MobileSectionCard>
          <MobileSectionHeader>
            <MobileSectionTitle>
              <span>{'\u{1F3C6}'}</span>
              <span>{mobileRankTab === 'school' ? 'My School Ranking' : 'All Schools Ranking'}</span>
            </MobileSectionTitle>
          </MobileSectionHeader>
          <MobileRankList>
            {ranking.map((item) => (
              <MobileRankItem key={`mobile-ranking-page-${item.user_name}-${item.rank}`}>
                <MobileRankBadge
                  $bg={
                    item.rank === 1
                      ? 'linear-gradient(135deg,#facc15,#f97316)'
                      : item.rank === 2
                        ? 'linear-gradient(135deg,#94a3b8,#cbd5e1)'
                        : item.rank === 3
                          ? 'linear-gradient(135deg,#b45309,#fb923c)'
                          : '#eaf7fb'
                  }
                >
                  {item.rank === 1 ? '\u{1F947}' : item.rank === 2 ? '\u{1F948}' : item.rank === 3 ? '\u{1F949}' : item.rank}
                </MobileRankBadge>
                <MobileRankName>{item.user_name}</MobileRankName>
                <MobileRankBooks>{`\u{1F4DA} ${item.book_count}`}</MobileRankBooks>
              </MobileRankItem>
            ))}
          </MobileRankList>
        </MobileSectionCard>
      </MobilePageShell>
      {mobileBottomNav}
    </MobileHomePage>
  );
  const mobileProfileContent = (
    <MobileHomePage>
      {mobileHeader}
      <MobilePageShell>
        <MobileProfileHero>
          <MobileProfileTop>
            <MobileProfileAvatar>{'\u{1F989}'}</MobileProfileAvatar>
            <div>
              <MobileProfileName>{userData?.name || 'LevelUp Reader'}</MobileProfileName>
              <MobileProfileId>{`ID: ${userData?.id || '-'}`}</MobileProfileId>
              <MobileProfileGrade>{userData?.school_grade || ''}</MobileProfileGrade>
            </div>
          </MobileProfileTop>
          <MobileProfileLexileRow>
            <div>
              {renderLexileValue(MobileProfileLexileValue)}
              <div style={{ fontSize: 11, fontWeight: 800, color: 'rgba(255,255,255,.78)' }}>MY LEXILE MEASURE</div>
            </div>
            <MobileProfileBadge>{`mx${formatMxLevel(normalizedCurrentLevel)}`}</MobileProfileBadge>
          </MobileProfileLexileRow>
        </MobileProfileHero>
        <ClassLevelCard style={{ margin: 0, width: '100%' }}>
          <ClassLevelTop>
            <div>
              <ClassLevelKicker>CLASS LEVEL</ClassLevelKicker>
              <ClassLevelName>{`Level ${currentLevel === 'PH' ? 'PH' : currentLevel || '-'}`}</ClassLevelName>
            </div>
            <ClassLevelBadge>{currentLevel === 'PH' ? 'P' : currentLevel || '-'}</ClassLevelBadge>
          </ClassLevelTop>
          <InfoText>{`Lexile ${MXLEVEL_TO_LEXILE[currentLevel] || '-'} ~ ${MXLEVEL_TO_LEXILE[currentLevel + 1] || '-'}`}</InfoText>
          <InfoText>{`AGL ${MXLEVEL_TO_AGL[currentLevel] || '-'}`}</InfoText>
        </ClassLevelCard>
        <InfoBtn
          type="button"
          onClick={() => history.push('/level-up/calendar')}
          style={{ width: '100%', justifyContent: 'space-between', marginTop: '-2px' }}
        >
          <span>{'\u{1F5D3}'} Points & Calendar</span>
          <span>{'\u{2192}'}</span>
        </InfoBtn>
        <MobilePointHero>
          <div>
            <MobilePointNum>{levelupPoint.monthly || 0}</MobilePointNum>
            <div style={{ fontSize: 9, fontWeight: 700, opacity: 0.72 }}>MONTHLY POINTS</div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 800 }}>{`목표 ${levelupPoint.goal || 0} points`}</div>
            <MobilePointTrack>
              <MobilePointFill $percent={((levelupPoint.monthly || 0) / Math.max(levelupPoint.goal || 1, 1)) * 100} />
            </MobilePointTrack>
            <div style={{ fontSize: 10, marginTop: 4, opacity: 0.72, textAlign: 'right' }}>
              {`목표까지 ${Math.max((levelupPoint.goal || 0) - (levelupPoint.monthly || 0), 0)}pt 남았어요`}
            </div>
          </div>
        </MobilePointHero>
        <MobileSectionCard>
          <MobileSectionHeader>
            <MobileSectionTitle>
              <span>{'\u{1F3C6}'}</span>
              <span>All Schools Ranking</span>
            </MobileSectionTitle>
          </MobileSectionHeader>
          <MobileRankList>
            {ranking.slice(0, 3).map((item) => (
              <MobileRankItem key={`mobile-profile-rank-${item.user_name}-${item.rank}`}>
                <MobileRankBadge
                  $bg={
                    item.rank === 1
                      ? 'linear-gradient(135deg,#facc15,#f97316)'
                      : item.rank === 2
                        ? 'linear-gradient(135deg,#94a3b8,#cbd5e1)'
                        : item.rank === 3
                          ? 'linear-gradient(135deg,#b45309,#fb923c)'
                          : '#eaf7fb'
                  }
                >
                  {item.rank === 1 ? '\u{1F947}' : item.rank === 2 ? '\u{1F948}' : item.rank === 3 ? '\u{1F949}' : item.rank}
                </MobileRankBadge>
                <MobileRankName>{item.user_name}</MobileRankName>
                <MobileRankBooks>{`\u{1F4DA} ${item.book_count}`}</MobileRankBooks>
              </MobileRankItem>
            ))}
          </MobileRankList>
        </MobileSectionCard>
        <MobileSectionCard>
          <MobileSectionHeader>
            <MobileSectionTitle>
              <span>{'\u{1F464}'}</span>
              <span>My Ranking</span>
            </MobileSectionTitle>
          </MobileSectionHeader>
          {currentUserRank ? (
            <MobileRankList>
              <MobileRankItem>
                <MobileRankBadge $bg="linear-gradient(135deg,#0ea5e9,#22c55e)">{currentUserRank.rank}</MobileRankBadge>
                <MobileRankName>{currentUserRank.user_name}</MobileRankName>
                <MobileRankBooks>{`\u{1F4DA} ${currentUserRank.book_count}`}</MobileRankBooks>
              </MobileRankItem>
            </MobileRankList>
          ) : (
            <MobileEmptyBox>{'\u{1F50D}'} Ranking data not found</MobileEmptyBox>
          )}
        </MobileSectionCard>
      </MobilePageShell>
      {mobileBottomNav}
    </MobileHomePage>
  );
  const mobilePageContent =
    mobilePage === 'ranking' ? mobileRankingContent : mobilePage === 'profile' ? mobileProfileContent : mobileHomeContent;
  return (
    <Wrapper ref={wrapperRef} className="cust-my-page" isMobile={window.isNativeAppMobile || isMobileOnly}>
      {!(window.isNativeAppMobile || isMobileOnly) && (
        <Header heightScale={height} isMobile={false}>
          <>
            {/* <div
              onClick={() => {
                history.push('/level-up');
              }}
              style={{ cursor: 'pointer' }}
            > */}
            <img
              onClick={() => {
                history.push('/level-up');
              }}
              src="/images/level_up_logo.svg"
              style={{ width: '205px', height: '43px', cursor: 'pointer' }}
              alt="logo"
            />
            {/* </div> */}
            <HeadBox
              heightScale={height}
              background="transparent"
              color={'#fff'}
              style={{ float: 'right', display: 'flex', position: 'absolute', right: '0px', top: '15px', alignItems: 'center' }}
            >
              <FullScreenButton
                element={<ImgButton heightScale={height} className="header-btn" src="/images/fullscreen.png" alt="back arrow in header" />}
                activeElement={
                  <ImgButton heightScale={height} className="header-btn" src="/images/fullscreenExit.png" alt="back arrow in header" />
                }
              />
              <SearchInput
                onPressEnter={handleSearch}
                onChange={handleInputChange}
                allowClear
                enterButton
                bordered={false}
                placeholder="Search"
                suffix={<SearchOutlined onClick={handleSearch} style={{ border: 'none', fontSize: '15px' }} />}
              />
              <span style={{ color: '#999', marginLeft: 5, fontSize: '15px' }}>
                <span className="username">
                  {userData?.name.length > 5 ? `${userData?.name.slice(0, 5)}...` : userData?.name}{' '}
                  <Text strong>
                    ({userData?.id.length > 9 ? `${userData?.id.slice(0, 9)}...` : userData?.id})
                    </Text>
                </span>
              </span>
              <a href="https://cdn.cloubot.com/LEVELUP/guide/index.html" target="_blank" style={{ marginLeft: '5px' }}>
                <Icon url={'/images/i-tutorial@2x.png'} width={'120px'} height={'35px'} />
              </a>
              <CloseButton
                onClick={() => {
                  history.push('/');
                }}
              >
                <PoweroffOutlined />
              </CloseButton>
            </HeadBox>
          </>
        </Header>
      )}
      <MainWrapper className="cust-main-wrap" width={width} height={height} isMobile={window.isNativeAppMobile || isMobileOnly}>
        <Main className="cust-inner-bg" width={width} height={height} isMobile={window.isNativeAppMobile || isMobileOnly}>
          {window.isNativeAppMobile || isMobileOnly ? (
            mobilePageContent
          ) : (
            <ColumnFlex style={{ display: 'contents' }}>
              <DesktopLeftMenuWrap>
                <LeftMenu2
                  isMain
                  myLevel={parseInt(type) !== 0 ? -2 : currentLevel === 'PH' ? 0 : parseInt(currentLevel)}
                  isStudent={parseInt(type) === 0}
                />
              </DesktopLeftMenuWrap>
              {desktopCenterContent}
              {false && (
                <>
                  <ColumnFlex>
                    <Title style={{ margin: '0 25px 25px' }}>
                      <span>{'\u{1F4DA}'}</span>
                      <span>Recommended Books</span>
                    </Title>
                    {loading && <Spin style={{ marginLeft: '10px' }} size="small" />}
                    <Carousel3 books={books} row={width <= 0.8 ? 3 : 4} handleFav={getHandleData} />
                  </ColumnFlex>
                  <RowFlex style={{ justifyContent: 'space-between', padding: '20px' }}>
                    <MiddleBox style={{ width: '100%', marginRight: '20px', paddingBottom: 0 }}>
                      <RowFlex style={{ justifyContent: 'start', width: '100%' }}>
                        <SubTitle>
                          {subdomain === 'gnb2' ? (
                            <>?낆꽌 紐낆뼵</>
                          ) : (
                            <>
                              <span>{'\u{1F4D8}'}</span>
                              <span>Assigned Books</span> <span style={{ color: '#8fa3bb' }}>| </span>
                              <span style={{ color: '#8fa3bb', fontSize: '12px', fontFamily: 'monospace' }}>
                                {' '}
                                {moment().format('YYYY.MM.DD')}
                              </span>
                            </>
                          )}
                        </SubTitle>
                      </RowFlex>
                      {subdomain === 'gnb2' ? (
                        <MiddleInnerBox style={{ paddingTop: 0 }}>
                          <ColumnFlex style={{ alignItems: 'center', lineHeight: '2', fontSize: '15px' }}>
                            <div> ?ㅻ뒛???섎? ?덇쾶 ??寃껋? ?곕━ 留덉쓣???꾩꽌愿?댁뿀??</div>
                            <div> ?섎쾭??議몄뾽?λ낫???뚯쨷??寃껋씠 ?낆꽌?섎뒗 ?듦??대떎.</div>
                            <div>What made me who I am today was the library in my village.</div>
                            <div>The habit of reading is more precious than a Harvard diploma.</div>

                            <div style={{ fontSize: '14px' }}>- 鍮?寃뚯씠痢?(Bill Gates) -</div>
                          </ColumnFlex>
                        </MiddleInnerBox>
                      ) : assignedBooks?.length > 0 ? (
                        <MiddleInnerBox>
                          <AssignedImg
                            // preview={false}
                            // width={135}
                            // height={180}
                            src={assignedBooks[currentAssignIndx].image}
                            // style={{ cursor: 'pointer' }}
                            is_completed={assignedBooks[currentAssignIndx].is_done}
                            onClick={() => {
                              !assignedBooks[currentAssignIndx].is_done &&
                                history.push(
                                  `/level-up/${
                                    assignedBooks[currentAssignIndx]?.is_voca
                                      ? 'study'
                                      : `${assignedBooks[currentAssignIndx]?.is_interactive ? 'epub-' : ''}reader`
                                  }/${assignedBooks[currentAssignIndx]?.code}`,
                                  {
                                    assigned_idx: assignedBooks[currentAssignIndx]?.assigned_idx,
                                    external_study_idx: assignedBooks[currentAssignIndx]?.external_study_idx,
                                    bookData: assignedBooks[currentAssignIndx],
                                  },
                                );
                            }}
                          >
                            {assignedBooks[currentAssignIndx].is_done && (
                              <Image width={110} height={110} preview={false} src={'/images/LevelUp/completed_levelup.png'} />
                            )}
                          </AssignedImg>
                          <ColumnFlex style={{ height: '100%', justifyContent: 'space-between' }}>
                            <MiddleInnerText>{assignedBooks[currentAssignIndx].title}</MiddleInnerText>
                            <MiddleInnerText color={'#0ba8ff'}>By {assignedBooks[currentAssignIndx].author}</MiddleInnerText>
                            <MiddleInnerText>
                              Lexile
                              {assignedBooks[currentAssignIndx].lexile_val < 0
                                ? ` BR${Math.abs(assignedBooks[currentAssignIndx].lexile_val)}L`
                                : ` ${assignedBooks[currentAssignIndx].lexile_val}L`}
                            </MiddleInnerText>
                            <MiddleInnerText>MX {assignedBooks[currentAssignIndx].mx_level}</MiddleInnerText>
                            <MiddleInnerText>
                              Assigned for{' '}
                              <span style={{ color: '#a06434' }}>
                                {moment(assignedBooks[currentAssignIndx].assigned_date).format('YYYY.MM.DD')}
                              </span>
                            </MiddleInnerText>
                          </ColumnFlex>
                          {assignedBooks?.length > 1 && (
                            <Icon
                              url={'/images/book/arrow-next.png'}
                              width={'12px'}
                              height={'19px'}
                              onClick={handleNextAssigned}
                              style={{ cursor: 'pointer' }}
                            />
                          )}
                        </MiddleInnerBox>
                      ) : (
                        <MiddleInnerBox>
                          <div
                            style={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'end',
                              justifyContent: 'center',
                              fontWeight: 600,
                              color: '#a19e9e',
                              whiteSpace: 'nowrap',
                              backgroundImage: 'url(/images/LevelUp/levelup_owl.png)',
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: '160px 148px',
                              backgroundPosition: 'center',
                            }}
                          >
                            {'\u{1F989}'} No Assigned Books
                          </div>
                        </MiddleInnerBox>
                      )}
                    </MiddleBox>
                    {width > 0.8 && (
                      <MiddleBox style={{ padding: '13px 15px 15px' }}>
                        <RowFlex>
                          <SubTitle>
                            <span>{'\u{1F4D6}'}</span>
                            <span>Currently Reading</span>
                          </SubTitle>
                          {lastReadBook ? (
                            <Link
                              to={{
                                pathname:
                                  type > 0 && company_name !== 'gnb'
                                    ? `/level-up/description/${lastReadBook?.code}`
                                    : `/level-up/${
                                        lastReadBook?.is_voca ? 'study' : `${lastReadBook?.is_interactive ? 'epub-' : ''}reader`
                                      }/${lastReadBook?.code}`,
                                state: { bookData: lastReadBook, assigned_idx: lastReadBook?.assigned_idx || null },
                              }}
                            ></Link>
                          ) : null}
                        </RowFlex>
                        {lastReadBook ? (
                          <RowFlex style={{ paddingTop: '10px', height: '100%' }}>
                            <CarouselItem3 data={lastReadBook} margin={'0'} handleFav={refetchLast} />
                          </RowFlex>
                        ) : (
                          <RowFlex style={{ paddingTop: '20px', height: '100%' }}>
                            <div
                              style={{
                                width: '170px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                fontWeight: 600,
                                color: '#a19e9e',
                              }}
                            >
                              {'\u{1F4D6}'} No reading data
                            </div>
                          </RowFlex>
                        )}
                      </MiddleBox>
                    )}
                  </RowFlex>
                </>
              )}
              <RightRail>
                <ColumnFlex style={{ width: '100%' }}>
                  <RightTopStack>
                    <ProfileHero>
                      <HeroTopRow>
                        <HeroAvatar>{'\u{1F989}'}</HeroAvatar>
                        <ColumnFlex>
                          <HeroName>{userData?.name}</HeroName>
                          <HeroId>{`ID: ${userData?.id}`}</HeroId>
                          <HeroGrade>{userData?.school_grade}</HeroGrade>
                        </ColumnFlex>
                      </HeroTopRow>
                      <HeroBottomRow>
                        <div>
                          {renderLexileValue(HeroLexileValue)}
                          <HeroLexileLabel>MY LEXILE MEASURE</HeroLexileLabel>
                        </div>
                        <HeroMxBadge>{`\u{1F4CA} mx${String(currentLevel).padStart(2, '0') || '-'}`}</HeroMxBadge>
                      </HeroBottomRow>
                    </ProfileHero>
                    <ClassLevelCard>
                      <ClassLevelTop>
                        <div>
                          <ClassLevelKicker>CLASS LEVEL</ClassLevelKicker>
                          <ClassLevelName>{`Level ${currentLevel || '-'}`}</ClassLevelName>
                        </div>
                        <ClassLevelBadge>{currentLevel === 'PH' ? 'P' : currentLevel || '-'}</ClassLevelBadge>
                      </ClassLevelTop>
                      <InfoText>
                        <span style={{ color: 'black', marginRight: '5px' }}>Lexile</span>{' '}
                        {currentLevel ? MXLEVEL_TO_LEXILE[currentLevel] : ''}
                      </InfoText>
                      <InfoText>
                        <span style={{ color: 'black', marginRight: '5px' }}>AGL</span>
                        {currentLevel ? MXLEVEL_TO_AGL[currentLevel] : ''}
                      </InfoText>
                    </ClassLevelCard>
                    <InfoBtn
                      onClick={() => {
                        history.push('/level-up/calendar');
                      }}
                    >
                      <span>{'\u{1F5D3}'} Points & Calendar</span>
                      <span>{'\u2192'}</span>
                    </InfoBtn>
                  </RightTopStack>
                  {width > 0.8 ? (
                    <RightBox>
                      <RowFlex style={{ justifyContent: 'space-between' }}>
                        <SubTitle>
                          <span>{'\u{1F3AF}'}</span>
                          <span>Monthly Points</span>
                        </SubTitle>
                        {/* <SettingTwoTone twoToneColor={'#aaa'} style={{ color: '#aaa', fontSize: '18px' }} /> */}
                      </RowFlex>
                      <PointText>
                        <PointNow>{levelupPoint.monthly}</PointNow>
                        <PointGoal>{`/ ${levelupPoint.goal} points`}</PointGoal>
                      </PointText>
                      <PointGraph>
                        <GraphFill mypoint={levelupPoint.monthly} totalpoint={levelupPoint.goal || 0} />
                      </PointGraph>
                      
                    <PointNote>{`목표까지 ${Math.max(levelupPoint.goal - levelupPoint.monthly, 0)}pt 남았어요!`}</PointNote>

                      {/* <PointDetailList>
                      {pointDetailItems.map((item) => (
                        <PointDetailRow key={item.label}>
                          <PointDetailLabel>{item.label}</PointDetailLabel>
                          <PointDetailValue background={item.background} color={item.color}>
                            {item.value}
                          </PointDetailValue>
                        </PointDetailRow>
                      ))}
                    </PointDetailList> */}
                    </RightBox>
                  ) : (
                    <MiddleBox style={{ padding: '13px 15px 15px', marginBottom: 10 }}>
                      <RowFlex>
                        <SubTitle>
                          <span>{'\u{1F4D6}'}</span>
                          <span>Currently Reading</span>
                        </SubTitle>
                        {lastReadBook ? (
                          <Link
                            to={{
                              pathname:
                                type > 0 && company_name !== 'gnb'
                                  ? `/level-up/description/${lastReadBook?.code}`
                                  : `/level-up/${lastReadBook?.is_voca ? 'study' : `${lastReadBook?.is_interactive ? 'epub-' : ''}reader`}/${
                                      lastReadBook?.code
                                    }`,
                              state: { bookData: lastReadBook, assigned_idx: lastReadBook?.assigned_idx || null },
                            }}
                          ></Link>
                        ) : null}
                      </RowFlex>
                      {lastReadBook ? (
                        <RowFlex style={{ paddingTop: '10px', height: '100%' }}>
                          <CarouselItem3 data={lastReadBook} margin={'0'} handleFav={refetchLast} />
                        </RowFlex>
                      ) : (
                        <RowFlex style={{ paddingTop: '20px', height: '100%' }}>
                          <div
                            style={{
                              width: '170px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: '100%',
                              fontWeight: 600,
                              color: '#a19e9e',
                              minHeight: '203px',
                            }}
                          >
                            {'\u{1F4D6}'} No reading data
                          </div>
                        </RowFlex>
                      )}
                    </MiddleBox>
                  )}
                  <RightBox style={{ paddingBottom: rankToggle === 'fc' && '7px' }}>
                    <RowFlex onClick={() => handleRankToggle('fc')} style={{ cursor: 'pointer', justifyContent: 'space-between' }}>
                      <SubTitle>
                        <span>{'\u{1F3C6}'}</span>
                        <span>All Schools Ranking</span>
                      </SubTitle>
                      {rankToggle === 'fc' ? (
                        <UpOutlined style={{ color: '#aaa', fontSize: '18px' }} />
                      ) : (
                        <DownOutlined style={{ color: '#aaa', fontSize: '18px' }} />
                      )}
                    </RowFlex>
                    {rankToggle === 'fc' && (
                      <RankingTable
                        columns={rankColumns}
                        pagination={{ pageSize: height > 0.85 ? 5 : 3 }}
                        size="small"
                        dataSource={ranking}
                      />
                    )}
                  </RightBox>
                  <RightBox style={{ paddingBottom: rankToggle === 'current' && '7px' }}>
                    <RowFlex onClick={() => handleRankToggle('current')} style={{ cursor: 'pointer', justifyContent: 'space-between' }}>
                      <SubTitle>
                        <span>{'\u{1F3EB}'}</span>
                        <span>Your School Ranking</span>
                      </SubTitle>
                      {rankToggle === 'current' ? (
                        <UpOutlined style={{ color: '#aaa', fontSize: '18px' }} />
                      ) : (
                        <DownOutlined style={{ color: '#aaa', fontSize: '18px' }} />
                      )}
                    </RowFlex>
                    {rankToggle === 'current' && (
                      <RankingTable
                        columns={rankColumns}
                        pagination={{ pageSize: height > 0.85 ? 5 : 3 }}
                        size="small"
                        dataSource={ranking}
                      />
                    )}
                  </RightBox>
                </ColumnFlex>
              </RightRail>
            </ColumnFlex>
          )}
        </Main>
      </MainWrapper>
    </Wrapper>
  );
}

const RankingTable = styled(Table)`
  margin-top: 12px;
  .ant-table {
    background: transparent;
    font-family: 'Nunito', sans-serif;
  }
  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 0;
  }
  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 0;
  }
  .ant-table-thead > tr > th {
    font-family: 'JetBrains Mono', monospace;
    padding: 8px 8px !important;
    background: transparent !important;
    border-bottom: 1px solid rgba(8, 145, 178, 0.14) !important;
    color: #8fa3bb;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: 0.18em;
    text-transform: uppercase;
  }
  .ant-table-tbody {
    line-height: 1;
  }
  .ant-table-tbody > tr > td {
    font-family: 'Nunito', sans-serif;
    padding: 0 8px !important;
    border-bottom: 1px solid rgba(8, 145, 178, 0.1) !important;
    background: transparent !important;
    font-size: 12px;
    font-weight: 800;
    color: #0c1a2e;
    height: 38px;
  }
  .ant-table-pagination.ant-pagination {
    margin: 12px 0 0;
    display: flex;
    justify-content: center;
  }
  .ant-pagination-item,
  .ant-pagination-prev .ant-pagination-item-link,
  .ant-pagination-next .ant-pagination-item-link {
    font-family: 'Nunito', sans-serif;
    min-width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 1px solid rgba(8, 145, 178, 0.18);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
  }
  .ant-pagination-item-active {
    background: #0891b2;
    border-color: #0891b2;
  }
  .ant-pagination-item-active a {
    color: #ffffff;
  }
`;
const rankColumns = [
  {
    title: 'Rank',
    dataIndex: 'rank',
    key: 'rank',
    align: 'center',
    render: (value) => {
      if (value === 1) {
        return (
          <RankValue background="linear-gradient(135deg,#facc15,#f97316)" color="#fff" shadow="0 2px 8px rgba(249,115,22,.3)">
            🥇
          </RankValue>
        );
      }
      if (value === 2) {
        return (
          <RankValue background="linear-gradient(135deg,#94a3b8,#cbd5e1)" color="#fff">
            🥈
          </RankValue>
        );
      }
      if (value === 3) {
        return (
          <RankValue background="linear-gradient(135deg,#b45309,#d97706)" color="#fff">
            🥉
          </RankValue>
        );
      }
      return (
        <RankValue background="#dbeafe" color="#64748b">
          {value}
        </RankValue>
      );
    },
  },
  {
    title: 'Name',
    dataIndex: 'user_name',
    key: 'user_name',
    align: 'center',
    render: (text, record) => {
      let tmp = text;
      tmp = tmp.length > 4 ? tmp.slice(0, 5) + '...' : tmp;
      return <span> {tmp}</span>;
    },
  },
  {
    title: 'Books',
    dataIndex: 'book_count',
    key: 'book_count',
    align: 'center',
    render: (value) => (
      <BookCountBadge>
        {'\u{1F4DA}'} {value}
      </BookCountBadge>
    ),
  },
];
